import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.hanscribe.encounter.board');
import { HostListener, OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { hanscribeCan, hanscribePrecheckBadgeClass, hanscribeStatusBadgeClass } from "src/libs/portal/hanscribe/hanscribe";

type BoardItem = Record<string, any>;

@Component({
    selector: 'wiz-portal-hanscribe-encounter-board',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.hanscribe.encounter.board/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.encounter-board {
  --board-bg: #f2f1ec;
  --board-surface: #fffefa;
  --board-surface-soft: #f8f7f2;
  --board-surface-muted: #efefea;
  --board-ink: #1d2622;
  --board-body: #45514c;
  --board-muted: #5f6964;
  --board-border: #dedfd8;
  --board-border-strong: #c9cdc5;
  --board-primary: #17483e;
  --board-primary-hover: #205b4f;
  --board-primary-dark: #123a32;
  --board-primary-soft: #e8efeb;
  --board-focus: rgba(23, 72, 62, 0.18);
  min-height: 100%;
  background: var(--board-bg);
  color: var(--board-ink);
}

.encounter-board,
.encounter-board * {
  box-sizing: border-box;
}

.encounter-board button,
.encounter-board input,
.encounter-board select {
  font: inherit;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.board-shell {
  display: flex;
  width: min(100%, 1680px);
  margin: 0 auto;
  padding: 24px 28px 36px;
  flex-direction: column;
  gap: 16px;
}

.board-header {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.board-heading,
.header-actions,
.overview-label,
.alert-row,
.patient-main,
.actions-cell {
  display: flex;
  align-items: center;
}

.board-heading {
  min-width: 0;
  gap: 13px;
}

.board-heading-icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d3dbd5;
  border-radius: 13px;
  background: #e8eeea;
  color: var(--board-primary);
  box-shadow: 0 5px 14px rgba(31, 53, 46, 0.07);
}

.board-heading-icon svg {
  width: 21px;
  height: 21px;
}

.title-block {
  min-width: 0;
}

.title-block h1,
.visit-panel-header h2 {
  margin: 0;
  color: var(--board-ink);
  font-size: 25px;
  line-height: 30px;
  font-weight: 760;
  letter-spacing: -0.035em;
}

.header-actions {
  flex: 0 0 auto;
  gap: 8px;
}

.board-workspace {
  display: grid;
  min-width: 0;
  gap: 12px;
}

.business-date-bar {
  display: flex;
  min-width: 0;
  min-height: 60px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 1px solid var(--board-border);
  border-radius: 14px;
  background: var(--board-surface);
  padding: 7px 10px;
  box-shadow: 0 8px 24px rgba(36, 47, 42, 0.035);
}

.business-date-main {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.date-arrow,
.today-button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--board-border-strong);
  border-radius: 9px;
  background: #ffffff;
  color: var(--board-body);
  cursor: pointer;
  font-weight: 750;
}

.date-arrow {
  width: 40px;
  flex: 0 0 40px;
  padding: 0;
  font-size: 23px;
  line-height: 1;
}

.today-button {
  min-width: 54px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 16px;
}

.date-arrow:hover:not(:disabled),
.today-button:hover:not(:disabled) {
  border-color: #aebbb4;
  background: var(--board-primary-soft);
  color: var(--board-primary);
}

.today-button.is-current {
  border-color: #c8d8d1;
  background: var(--board-primary-soft);
  color: var(--board-primary);
}

.business-date-picker-wrap {
  position: relative;
  min-width: 270px;
}

.business-date-picker {
  display: flex;
  width: 100%;
  height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #d5d9d3;
  border-radius: 10px;
  background: #faf9f5;
  padding: 3px 5px 3px 12px;
  color: inherit;
  cursor: pointer;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.business-date-picker:hover:not(:disabled) {
  border-color: #b6c4bd;
  background: #ffffff;
}

.business-date-picker[aria-expanded=true] {
  border-color: var(--board-primary);
  background: #ffffff;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.business-date-picker:focus-visible {
  outline: none;
  border-color: var(--board-primary);
  box-shadow: 0 0 0 3px var(--board-focus);
}

.business-date-picker > span:first-child {
  min-width: 0;
}

.business-date-picker small,
.business-date-picker strong {
  display: block;
}

.business-date-picker small {
  color: #5f6964;
  font-size: 13px;
  line-height: 16px;
  font-weight: 680;
}

.business-date-picker strong {
  overflow: hidden;
  color: var(--board-ink);
  font-size: 14px;
  line-height: 20px;
  font-weight: 770;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-trigger-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e4de;
  border-radius: 8px;
  background: #ffffff;
  color: var(--board-primary);
}

.calendar-trigger-icon svg {
  width: 18px;
  height: 18px;
}

.calendar-popover {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 60;
  width: 320px;
  border: 1px solid #cfd6d0;
  border-radius: 16px;
  background: #fffefa;
  padding: 13px;
  box-shadow: 0 22px 54px rgba(29, 45, 38, 0.18), 0 3px 10px rgba(29, 45, 38, 0.08);
  animation: board-calendar-in 150ms ease-out both;
}

.calendar-header {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 36px;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.calendar-header > strong {
  color: var(--board-ink);
  font-size: 15px;
  line-height: 22px;
  font-weight: 780;
  text-align: center;
}

.calendar-nav-button {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--board-border);
  border-radius: 9px;
  background: #ffffff;
  color: var(--board-body);
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  font-weight: 700;
}

.calendar-nav-button:hover,
.calendar-nav-button:focus-visible {
  border-color: #abc0b7;
  background: var(--board-primary-soft);
  color: var(--board-primary);
  outline: none;
}

.calendar-weekdays,
.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
}

.calendar-weekdays {
  margin-bottom: 4px;
}

.calendar-weekdays span {
  display: flex;
  height: 26px;
  align-items: center;
  justify-content: center;
  color: #7c8681;
  font-size: 13px;
  line-height: 17px;
  font-weight: 700;
}

.calendar-weekdays span:first-child {
  color: #aa5e55;
}

.calendar-weekdays span:last-child {
  color: #527a9d;
}

.calendar-day {
  position: relative;
  display: inline-flex;
  height: 36px;
  min-width: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: var(--board-body);
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 650;
}

.calendar-day:hover,
.calendar-day:focus-visible {
  border-color: #c2d0c9;
  background: var(--board-primary-soft);
  color: var(--board-primary-dark);
  outline: none;
}

.calendar-day.is-outside-month {
  color: #a7ada9;
  font-weight: 560;
}

.calendar-day.is-today {
  border-color: #afc8bd;
  color: var(--board-primary);
  font-weight: 800;
}

.calendar-day.is-selected {
  border-color: var(--board-primary);
  background: var(--board-primary);
  color: #ffffff;
  font-weight: 800;
  box-shadow: 0 5px 12px rgba(23, 72, 62, 0.18);
}

.calendar-day.is-selected:hover,
.calendar-day.is-selected:focus-visible {
  border-color: var(--board-primary-hover);
  background: var(--board-primary-hover);
  color: #ffffff;
}

.calendar-day > i {
  position: absolute;
  bottom: 3px;
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: currentColor;
}

.calendar-footer {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid #e4e6e0;
  margin-top: 10px;
  padding: 10px 2px 0;
}

.calendar-footer > span {
  min-width: 0;
  overflow: hidden;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 17px;
  font-weight: 620;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-footer > button {
  flex: 0 0 auto;
  min-height: 32px;
  border: 1px solid #c9d7d0;
  border-radius: 8px;
  background: var(--board-primary-soft);
  padding: 0 10px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 750;
}

.calendar-footer > button:hover,
.calendar-footer > button:focus-visible {
  border-color: #abc0b7;
  background: #dce9e3;
  outline: none;
}

.business-date-summary {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.business-date-summary > span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  border: 1px solid #e0e2dc;
  border-radius: 8px;
  background: #f7f6f1;
  padding: 0 8px;
  color: #69736e;
  font-size: 13px;
  line-height: 17px;
  font-weight: 620;
  white-space: nowrap;
}

.business-date-summary strong {
  color: var(--board-ink);
  font-size: 13px;
  font-weight: 800;
}

.business-date-summary .visit-mix {
  gap: 5px;
}

.business-date-summary .visit-mix i {
  color: #a6ada9;
  font-style: normal;
}

.business-date-summary .summary-attention {
  border-color: #f0d5ad;
  background: #fff8eb;
  color: #9a5b08;
}

.workspace-mode-bar {
  display: flex;
  min-height: 50px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--board-border);
  padding: 2px 2px 10px;
  scroll-margin-top: 12px;
}

.workspace-mode-switch {
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  border: 1px solid var(--board-border);
  border-radius: 12px;
  background: #e8e9e4;
  padding: 4px;
}

.workspace-mode-switch button {
  position: relative;
  display: inline-flex;
  min-width: 132px;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  padding: 0 14px;
  color: #66716c;
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
  font-weight: 720;
}

.workspace-mode-switch button strong {
  color: inherit;
  font-size: 13px;
  font-weight: 820;
}

.workspace-mode-switch button em {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #d8a548;
  color: #ffffff;
  font-size: 12px;
  font-style: normal;
  line-height: 1;
}

.workspace-mode-switch button:hover:not(:disabled) {
  color: var(--board-primary);
}

.workspace-mode-switch button.is-active {
  background: var(--board-surface);
  color: var(--board-primary);
  box-shadow: 0 2px 8px rgba(36, 47, 42, 0.1);
}

.workspace-mode-bar > p {
  margin: 0;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 560;
  text-align: right;
}

.status-overview {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: thin;
}

.overview-item {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 44px;
  flex: 1 0 112px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  overflow: hidden;
  border: 1px solid var(--board-border);
  border-radius: 10px;
  background: rgba(255, 254, 250, 0.88);
  padding: 8px 11px;
  color: inherit;
  cursor: pointer;
  text-align: left;
  box-shadow: none;
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
}

.overview-item::after {
  display: none;
}

.overview-item:hover:not(:disabled) {
  border-color: #b9c2bb;
  background: var(--board-surface);
  box-shadow: 0 3px 10px rgba(36, 47, 42, 0.06);
}

.overview-item.is-active {
  border-color: var(--board-primary);
  background: var(--board-primary);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(23, 72, 62, 0.13);
}

.overview-label {
  min-width: 0;
  gap: 8px;
  color: var(--board-muted);
  font-size: 14px;
  line-height: 20px;
  font-weight: 650;
  white-space: nowrap;
}

.overview-dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 999px;
  background: #94a3b8;
}

.overview-item strong {
  color: var(--board-ink);
  font-size: 16px;
  line-height: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.overview-item.is-active .overview-label,
.overview-item.is-active strong {
  color: #ffffff;
}

.overview-item.is-active .overview-dot {
  background: #b9d6cb;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.1);
}

.overview-item:disabled {
  cursor: wait;
  opacity: 0.72;
}

.overview-item-waiting .overview-dot {
  background: #d97706;
}

.overview-item-scheduled .overview-dot {
  background: #7c6ca8;
}

.overview-item-scheduled strong {
  color: #65568f;
}

.overview-item-waiting strong {
  color: #a85f05;
}

.overview-item-checked-in .overview-dot {
  background: #3b82f6;
}

.overview-item-checked-in strong {
  color: #2563a8;
}

.overview-item-progress .overview-dot {
  background: var(--board-primary-hover);
}

.overview-item-progress strong {
  color: var(--board-primary);
}

.overview-item-done .overview-dot {
  background: #059669;
}

.overview-item-done strong {
  color: #047857;
}

.overview-item-checkout .overview-dot {
  background: #b7791f;
}

.overview-item-checkout strong {
  color: #8a5a16;
}

.search-panel {
  border: 1px solid var(--board-border);
  border-radius: 14px;
  background: var(--board-surface);
  padding: 14px 16px 15px;
  box-shadow: 0 8px 24px rgba(36, 47, 42, 0.035);
}

.search-main {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto auto auto;
  gap: 8px;
  align-items: end;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(170px, 1fr)) minmax(260px, auto);
  gap: 12px;
  align-items: end;
  border-top: 1px solid #e5e5df;
  margin-top: 14px;
  padding-top: 14px;
  animation: board-filter-in 160ms ease-out both;
}

.filter-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
  color: var(--board-body);
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}

.field input,
.field select {
  width: 100%;
  height: 42px;
  border: 1px solid #d5d8d2;
  border-radius: 10px;
  background: #faf9f5;
  color: var(--board-ink);
  font-size: 14px;
  line-height: 20px;
  outline: none;
  padding: 0 12px;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.field input:hover,
.field select:hover {
  border-color: #b9c0ba;
  background: var(--board-surface);
}

.field input:focus,
.field select:focus {
  border-color: var(--board-primary);
  background: var(--board-surface);
  box-shadow: 0 0 0 3px var(--board-focus);
}

.encounter-board input::placeholder {
  color: #9a9f9b;
}

.search-input-shell {
  position: relative;
  display: block;
}

.search-input-shell > svg {
  position: absolute;
  top: 50%;
  left: 13px;
  z-index: 1;
  width: 18px;
  height: 18px;
  color: #78908a;
  pointer-events: none;
  transform: translateY(-50%);
}

.search-input-shell input {
  padding-left: 40px;
}

.toolbar-button,
.primary-query-button,
.secondary-button,
.ghost-button,
.create-visit-button,
.qa-button,
.start-button,
.precheck-button,
.close-button {
  display: inline-flex;
  min-width: 72px;
  height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0 13px;
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease, box-shadow 140ms ease, transform 140ms ease;
}

.header-create-button {
  height: 44px;
  padding-right: 16px;
  padding-left: 16px;
}

.toolbar-button,
.secondary-button,
.qa-button,
.precheck-button {
  border-color: var(--board-border-strong);
  background: #ffffff;
  color: var(--board-body);
}

.toolbar-button:hover:not(:disabled),
.secondary-button:hover:not(:disabled),
.qa-button:hover:not(:disabled),
.precheck-button:hover {
  border-color: #b6c7c2;
  background: var(--board-surface-soft);
  color: var(--board-primary-dark);
}

.primary-query-button,
.header-create-button,
.submit-visit-button,
.start-button {
  border-color: transparent;
  background: var(--board-primary);
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(23, 72, 62, 0.14);
}

.primary-query-button:hover:not(:disabled),
.header-create-button:hover:not(:disabled),
.submit-visit-button:hover:not(:disabled),
.start-button:hover:not(:disabled) {
  background: var(--board-primary-hover);
  box-shadow: 0 8px 20px rgba(23, 72, 62, 0.18);
  transform: translateY(-1px);
}

.ghost-button {
  border-color: transparent;
  background: transparent;
  color: var(--board-muted);
}

.ghost-button:hover:not(:disabled) {
  background: var(--board-surface-muted);
  color: var(--board-body);
}

.close-button {
  min-width: 42px;
  width: 42px;
  height: 42px;
  padding: 0;
  border-color: var(--board-border);
  background: #ffffff;
  color: var(--board-muted);
}

.close-button:hover {
  border-color: var(--board-border-strong);
  background: var(--board-surface-soft);
  color: var(--board-ink);
}

.filter-chevron {
  width: 14px;
  height: 14px;
  transition: transform 160ms ease;
}

.filter-chevron.is-open {
  transform: rotate(180deg);
}

.filter-count {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--board-primary);
  color: #ffffff;
  font-size: 13px;
  line-height: 1;
  font-weight: 800;
}

.active-filter-bar {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  border-top: 1px solid #e5e5df;
  margin-top: 14px;
  padding-top: 13px;
}

.active-filter-title {
  margin-right: 2px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}

.filter-chip {
  display: inline-flex;
  max-width: min(260px, 100%);
  min-height: 29px;
  align-items: center;
  gap: 7px;
  border: 1px solid #d1d9d3;
  border-radius: 999px;
  background: var(--board-primary-soft);
  padding: 4px 9px 4px 10px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 680;
}

.filter-chip > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-chip > span:last-child {
  flex: 0 0 auto;
  color: #6d8078;
  font-size: 15px;
  line-height: 1;
}

.filter-chip:hover:not(:disabled) {
  border-color: #aebdb5;
  background: #dfe9e4;
}

.filter-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.button-icon {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
}

.action-arrow {
  width: 16px;
  height: 16px;
  transition: transform 140ms ease;
}

.start-button:hover:not(:disabled) .action-arrow {
  transform: translateX(2px);
}

button:disabled,
a[disabled] {
  cursor: not-allowed;
  border-color: var(--board-border);
  background: var(--board-surface-muted);
  color: #94a3b8;
  box-shadow: none;
  opacity: 1;
  transform: none;
}

.toolbar-button:focus-visible,
.primary-query-button:focus-visible,
.secondary-button:focus-visible,
.ghost-button:focus-visible,
.create-visit-button:focus-visible,
.qa-button:focus-visible,
.start-button:focus-visible,
.precheck-button:focus-visible,
.close-button:focus-visible,
.debug-toggle:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.workspace-alert {
  margin: 0;
}

.alert {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 650;
}

.alert-row {
  gap: 9px;
}

.alert-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  align-items: center;
  justify-content: center;
}

.alert-icon svg {
  width: 18px;
  height: 18px;
}

.alert-error {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.alert-success {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}

.debug-toggle {
  width: fit-content;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #475569;
  cursor: pointer;
  font-size: 13px;
  font-weight: 750;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.debug-detail,
.debug-section {
  border: 1px dashed #cbd8d4;
  border-radius: 8px;
  background: var(--board-surface-soft);
  color: #475569;
}

.debug-detail {
  display: grid;
  gap: 4px;
  padding: 10px;
}

.debug-detail span,
.debug-section span {
  font-size: 13px;
  font-weight: 700;
}

.debug-detail code {
  color: var(--board-body);
  font-size: 13px;
  overflow-wrap: anywhere;
}

.debug-section {
  display: grid;
  gap: 10px;
  margin-top: 14px;
  padding: 12px;
}

.debug-fields {
  gap: 10px;
}

.carryover-alert {
  display: grid;
  gap: 10px;
  border: 1px solid #e8c98e;
  border-radius: 13px;
  background: #fff9ee;
  padding: 12px 14px;
}

.carryover-heading,
.carryover-heading > div,
.carryover-items,
.carryover-items article {
  display: flex;
  align-items: center;
}

.carryover-heading {
  justify-content: space-between;
  gap: 14px;
}

.carryover-heading > div {
  min-width: 0;
  gap: 9px;
}

.carryover-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #b96d0b;
  color: #ffffff;
  font-size: 13px;
  font-weight: 850;
}

.carryover-heading h2 {
  margin: 0;
  color: #664314;
  font-size: 13px;
  line-height: 18px;
  font-weight: 780;
}

.carryover-heading p {
  margin: 1px 0 0;
  color: #8d6a38;
  font-size: 13px;
  line-height: 18px;
  font-weight: 560;
}

.carryover-heading > strong {
  flex: 0 0 auto;
  color: #8c560d;
  font-size: 13px;
  line-height: 18px;
  font-weight: 800;
}

.carryover-items {
  min-width: 0;
  flex-wrap: wrap;
  gap: 7px;
}

.carryover-items article {
  min-width: min(260px, 100%);
  flex: 1 1 250px;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #eddab7;
  border-radius: 9px;
  background: #fffefa;
  padding: 8px 9px 8px 11px;
}

.carryover-items article > div {
  min-width: 0;
}

.carryover-items article strong,
.carryover-items article span {
  display: block;
}

.carryover-items article strong {
  overflow: hidden;
  color: var(--board-ink);
  font-size: 13px;
  line-height: 16px;
  font-weight: 740;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.carryover-items article div > span {
  margin-top: 1px;
  color: #8d7045;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.carryover-action {
  display: inline-flex;
  min-height: 30px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbb977;
  border-radius: 7px;
  background: #ffffff;
  padding: 0 9px;
  color: #80500d;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 740;
  text-decoration: none;
}

.carryover-action:hover {
  background: #fff4df;
}

.workflow-section {
  overflow: hidden;
  border: 1px solid var(--board-border);
  border-radius: 11px;
  background: var(--board-surface);
  box-shadow: none;
}

.workflow-header {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--board-border);
  padding: 8px 13px;
}

.section-title-line {
  display: flex;
  align-items: baseline;
  gap: 9px;
}

.section-title-line h2 {
  margin: 0;
  color: var(--board-ink);
  font-size: 16px;
  line-height: 22px;
  font-weight: 780;
  letter-spacing: -0.025em;
}

.workflow-total {
  color: var(--board-primary);
  font-size: 13px;
  line-height: 18px;
  font-weight: 760;
}

.workflow-subsection-header {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
}

.workflow-subsection-header > div {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 8px;
}

.workflow-subsection-header h3 {
  margin: 0;
  color: var(--board-ink);
  font-size: 14px;
  line-height: 19px;
  font-weight: 780;
}

.workflow-subsection-header span {
  color: var(--board-muted);
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
}

.workflow-subsection-header > strong {
  color: var(--board-body);
  font-size: 13px;
  line-height: 18px;
  font-weight: 780;
}

.appointment-agenda,
.workflow-group + .workflow-group {
  border-top: 1px solid var(--board-border);
}

.appointment-list {
  border-top: 1px solid var(--board-border);
}

.appointment-row {
  display: grid;
  min-width: 0;
  grid-template-columns: 62px minmax(160px, 1fr) minmax(130px, 0.7fr) auto auto;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #ecece7;
  padding: 9px 12px;
  background: #ffffff;
}

.appointment-row:last-child {
  border-bottom: 0;
}

.appointment-row time {
  color: var(--board-primary);
  font-size: 14px;
  line-height: 19px;
  font-weight: 800;
  white-space: nowrap;
}

.appointment-patient,
.appointment-assignment {
  min-width: 0;
}

.appointment-patient strong {
  display: block;
  overflow: hidden;
  color: var(--board-ink);
  font-size: 15px;
  line-height: 20px;
  font-weight: 760;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appointment-patient span,
.appointment-assignment {
  overflow: hidden;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appointment-empty {
  display: flex;
  min-height: 52px;
  align-items: center;
  border-top: 1px solid var(--board-border);
  padding: 0 12px;
  color: #818984;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.appointment-overflow {
  border-top: 1px solid var(--board-border);
  margin: 0;
  padding: 7px 12px;
}

.workflow-group {
  border-top: 1px solid var(--board-border);
}

.workflow-lanes {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1px;
  background: var(--board-border);
}

.workflow-empty-state {
  display: flex;
  min-height: 190px;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px;
  text-align: left;
}

.workflow-empty-icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--board-primary-soft);
  color: var(--board-primary);
  font-size: 18px;
  font-weight: 850;
}

.workflow-empty-state strong {
  color: var(--board-ink);
  font-size: 14px;
  line-height: 20px;
}

.workflow-empty-state p {
  margin: 3px 0 0;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
}

.workflow-empty-state button {
  min-height: 38px;
  border: 1px solid var(--board-border-strong);
  border-radius: 9px;
  background: #ffffff;
  padding: 0 13px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  font-weight: 740;
}

.workflow-lane {
  min-width: 0;
  background: #f6f6f2;
  padding: 9px;
}

.workflow-lane-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.workflow-lane-header > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.workflow-lane-dot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 999px;
  background: #7b938a;
}

.workflow-lane[data-lane=reception] .workflow-lane-dot {
  background: #c67612;
}

.workflow-lane[data-lane=waiting] .workflow-lane-dot {
  background: #74609f;
}

.workflow-lane[data-lane=in_progress] .workflow-lane-dot {
  background: #276d5e;
}

.workflow-lane[data-lane=checkout] .workflow-lane-dot {
  background: #326b9b;
}

.workflow-lane-header h3 {
  overflow: hidden;
  margin: 0;
  color: var(--board-ink);
  font-size: 14px;
  line-height: 19px;
  font-weight: 760;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-lane-header > strong {
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #e9e9e3;
  color: var(--board-body);
  font-size: 13px;
  line-height: 1;
  font-weight: 800;
}

.workflow-cards {
  display: grid;
  overflow: hidden;
  gap: 0;
  margin-top: 7px;
  border: 1px solid #e1e2dd;
  border-radius: 7px;
  background: #ffffff;
}

.workflow-card {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "main main" "assignment actions" "alerts actions";
  column-gap: 10px;
  row-gap: 3px;
  border: 0;
  border-bottom: 1px solid #ecece7;
  border-radius: 0;
  background: #ffffff;
  padding: 9px 10px;
  box-shadow: none;
}

.workflow-card:last-child {
  border-bottom: 0;
}

.workflow-card-main,
.workflow-card-alerts,
.workflow-card-actions {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.workflow-card-main {
  grid-area: main;
  justify-content: space-between;
}

.workflow-patient {
  min-width: 0;
}

.workflow-patient strong {
  display: block;
  overflow: hidden;
  color: var(--board-ink);
  font-size: 16px;
  line-height: 21px;
  font-weight: 780;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-patient > span {
  display: block;
  margin-top: 2px;
  color: #727b77;
  font-size: 13px;
  line-height: 18px;
  font-weight: 560;
}

.workflow-timing {
  flex: 0 0 auto;
  color: var(--board-primary);
  font-size: 13px;
  line-height: 17px;
  font-weight: 760;
  white-space: nowrap;
}

.workflow-assignment {
  grid-area: assignment;
  overflow: hidden;
  align-self: center;
  color: #5f6964;
  font-size: 13px;
  line-height: 17px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workflow-card-alerts {
  grid-area: alerts;
  flex-wrap: wrap;
  gap: 5px;
}

.workflow-attention {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border: 1px solid #ead5ad;
  border-radius: 999px;
  background: #fff8e9;
  padding: 2px 8px;
  color: #8a5a16;
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
}

.workflow-card-actions {
  grid-area: actions;
  align-self: end;
  justify-content: flex-end;
}

.workflow-action {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  padding: 0 5px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 750;
  text-decoration: none;
  white-space: nowrap;
}

.workflow-action:hover {
  background: var(--board-primary-soft);
}

.workflow-action-primary {
  background: var(--board-primary);
  color: #ffffff;
  padding-right: 8px;
  padding-left: 8px;
}

.workflow-action-primary:hover:not(:disabled) {
  background: var(--board-primary-hover);
}

.workflow-readonly {
  color: #7d8782;
  font-size: 13px;
  line-height: 17px;
  font-weight: 650;
}

.workflow-lane-empty {
  display: flex;
  min-height: 60px;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d7d9d3;
  border-radius: 9px;
  margin-top: 10px;
  color: #929994;
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
}

.workflow-overflow {
  display: block;
  margin-top: 8px;
  color: #747e79;
  font-size: 13px;
  line-height: 17px;
  font-weight: 620;
  text-align: right;
}

.today-queue {
  min-width: 0;
  background: #ffffff;
}

.today-queue-head,
.today-queue-row {
  display: grid;
  min-width: 0;
  grid-template-columns: 68px minmax(150px, 1.1fr) minmax(112px, 0.8fr) minmax(116px, 0.75fr) minmax(135px, 0.9fr) 154px;
  align-items: center;
  gap: 10px;
}

.today-queue-head {
  min-height: 34px;
  border-bottom: 1px solid var(--board-border);
  background: #f7f7f3;
  padding: 6px 12px;
  color: #737c77;
  font-size: 13px;
  line-height: 17px;
  font-weight: 700;
}

.today-queue-row {
  min-height: 58px;
  border-bottom: 1px solid #ecece7;
  padding: 8px 12px;
  background: #ffffff;
}

.today-queue-row:last-child {
  border-bottom: 0;
}

.today-queue-row:hover {
  background: #fbfcfa;
}

.today-queue-row time {
  color: var(--board-primary);
  font-size: 14px;
  line-height: 19px;
  font-weight: 820;
  white-space: nowrap;
}

.today-queue-patient,
.today-queue-state,
.today-queue-action-cell {
  min-width: 0;
}

.today-queue-patient strong {
  display: block;
  overflow: hidden;
  color: var(--board-ink);
  font-size: 15px;
  line-height: 20px;
  font-weight: 780;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.today-queue-patient span {
  display: block;
  overflow: hidden;
  margin-top: 1px;
  color: #727b77;
  font-size: 13px;
  line-height: 17px;
  font-weight: 580;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.today-queue-state {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.queue-status,
.queue-attention {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 13px;
  line-height: 16px;
  font-weight: 740;
  white-space: nowrap;
}

.queue-status--scheduled {
  background: #eef1ef;
  color: #5e6863;
}

.queue-status--checked_in {
  background: #fff1d8;
  color: #8b590d;
}

.queue-status--waiting {
  background: #eee9f8;
  color: #66518d;
}

.queue-status--in_progress {
  background: #dceee8;
  color: #1f6758;
}

.queue-status--checkout_pending {
  background: #e4eff8;
  color: #28638e;
}

.queue-status--done {
  background: #e8efe9;
  color: #496358;
}

.queue-status--cancelled,
.queue-status--no_show,
.queue-status--left_without_care {
  background: #f2ece9;
  color: #775a50;
}

.queue-status--unknown {
  background: #f0f1ee;
  color: #68716c;
}

.queue-attention {
  border: 1px solid #ead5ad;
  background: #fff8e9;
  color: #8a5a16;
}

.today-queue-timing,
.today-queue-assignment {
  overflow: hidden;
  color: #59635e;
  font-size: 13px;
  line-height: 18px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.today-queue-timing {
  color: #49665d;
  font-weight: 720;
}

.today-queue-action-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
}

.today-queue-action {
  display: inline-flex;
  min-width: 88px;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: var(--board-primary);
  padding: 0 10px;
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 760;
  white-space: nowrap;
}

.today-queue-action:hover:not(:disabled) {
  background: var(--board-primary-hover);
}

.today-queue-action:disabled {
  cursor: wait;
  opacity: 0.58;
}

.today-queue-detail-toggle {
  display: inline-flex;
  min-width: 58px;
  height: 34px;
  flex: 0 0 58px;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 1px solid #d9ddd8;
  border-radius: 8px;
  background: #ffffff;
  color: #626c67;
  cursor: pointer;
  padding: 0 7px;
  font-size: 13px;
  line-height: 17px;
  font-weight: 720;
}

.today-queue-detail-toggle svg {
  width: 14px;
  height: 14px;
  transition: transform 160ms ease;
}

.today-queue-detail-toggle svg.is-open {
  transform: rotate(180deg);
}

.today-queue-detail-toggle:hover,
.today-queue-detail-toggle[aria-expanded=true] {
  border-color: #b8c8c2;
  background: var(--board-primary-soft);
  color: var(--board-primary);
}

.unified-patient-row.is-expanded {
  background: #fbfcfa;
}

.patient-row-details {
  display: flex;
  min-width: 0;
  grid-column: 1/-1;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-top: 1px solid #e8ebe6;
  margin-top: 7px;
  padding-top: 9px;
}

.patient-row-facts {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
  gap: 8px 16px;
  margin: 0;
}

.patient-row-facts div {
  min-width: 0;
}

.patient-row-facts dt {
  color: #7b847f;
  font-size: 13px;
  line-height: 17px;
  font-weight: 650;
}

.patient-row-facts dd {
  overflow: hidden;
  margin: 2px 0 0;
  color: var(--board-body);
  font-size: 13px;
  line-height: 18px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-row-secondary-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
}

.patient-row-secondary-action {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9ddd8;
  border-radius: 7px;
  background: #ffffff;
  padding: 0 9px;
  color: #4f5c56;
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.patient-row-secondary-action:hover {
  border-color: #b8c8c2;
  background: #f5f8f6;
  color: var(--board-primary);
}

.patient-row-secondary-action.is-danger {
  color: #9a3f3a;
}

.today-queue-no-action {
  color: #a0a6a2;
  font-size: 14px;
}

.today-queue-overflow {
  width: 100%;
  min-height: 36px;
  border: 0;
  border-top: 1px solid var(--board-border);
  background: #fafaf7;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 720;
}

.today-queue-overflow:hover {
  background: var(--board-primary-soft);
}

.worklist-section {
  position: relative;
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--board-border);
  border-radius: 15px;
  background: var(--board-surface);
  box-shadow: 0 12px 34px rgba(36, 47, 42, 0.05);
}

.unified-patient-list {
  border-radius: 11px;
  box-shadow: none;
}

.worklist-toolbar {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px solid var(--board-border);
  padding: 14px 18px;
}

.worklist-title {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 10px;
}

.page-size-control select {
  height: 34px;
  border: 1px solid var(--board-border-strong);
  border-radius: 8px;
  background: #ffffff;
  color: var(--board-body);
  outline: none;
  cursor: pointer;
  font-size: 13px;
  line-height: 16px;
  font-weight: 650;
}

.page-size-control select:focus {
  border-color: var(--board-primary);
  box-shadow: 0 0 0 3px var(--board-focus);
}

.worklist-toolbar h2 {
  margin: 0;
  color: var(--board-ink);
  font-size: 17px;
  line-height: 22px;
  font-weight: 760;
  letter-spacing: -0.02em;
}

.list-result {
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.list-result strong {
  margin: 0 2px;
  color: var(--board-primary);
  font-size: 14px;
  font-weight: 800;
}

.patient-work-sections {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: start;
  background: #ffffff;
}

.patient-work-section {
  min-width: 0;
  border-right: 1px solid var(--board-border);
}

.patient-work-section:nth-child(3) {
  border-bottom: 0;
  border-right: 0;
}

.patient-work-section.is-closed-section {
  grid-column: 1/-1;
  border-top: 1px solid var(--board-border);
  border-right: 0;
}

.patient-section-heading {
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 0;
  border-bottom: 1px solid #e5e7e2;
  background: #f7f8f5;
  padding: 9px 16px;
  color: var(--board-ink);
  text-align: left;
}

.patient-section-heading h3,
.patient-section-heading strong {
  margin: 0;
  color: inherit;
  font-size: 15px;
  line-height: 20px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.patient-section-count,
.patient-section-toggle small {
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}

.patient-section-toggle {
  cursor: pointer;
  font: inherit;
}

.patient-section-toggle:hover {
  background: #f2f4f0;
}

.patient-section-toggle:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid var(--board-focus);
  outline-offset: -3px;
}

.patient-section-toggle > span {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
}

.patient-section-toggle svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  color: #6f7873;
  transition: transform 150ms ease;
}

.patient-section-toggle svg.is-open {
  transform: rotate(180deg);
}

.patient-work-section.is-closed-section .patient-section-heading {
  border-bottom: 0;
  background: #faf9f7;
  color: #5f6763;
}

.patient-work-section.is-closed-section.is-open .patient-section-heading {
  border-bottom: 1px solid #e5e7e2;
}

.patient-section-empty {
  display: flex;
  min-height: 48px;
  align-items: center;
  padding: 10px 16px;
  color: #858d89;
  font-size: 13px;
  line-height: 18px;
}

.patient-work-section:not(.is-closed-section) .today-queue-row {
  grid-template-columns: 48px minmax(0, 1fr) 88px;
  grid-template-areas: "time patient patient" "state state action" "timing assignment action" "details details details";
  align-items: start;
  gap: 4px 8px;
  min-height: 94px;
  padding: 10px 12px;
}

.patient-work-section:not(.is-closed-section) .today-queue-row time {
  grid-area: time;
  padding-top: 1px;
}

.patient-work-section:not(.is-closed-section) .today-queue-patient {
  grid-area: patient;
}

.patient-work-section:not(.is-closed-section) .today-queue-state {
  grid-area: state;
  align-self: center;
}

.patient-work-section:not(.is-closed-section) .today-queue-timing {
  grid-area: timing;
}

.patient-work-section:not(.is-closed-section) .today-queue-assignment {
  grid-area: assignment;
}

.patient-work-section:not(.is-closed-section) .today-queue-action-cell {
  grid-area: action;
  align-self: stretch;
  align-items: stretch;
  flex-direction: column;
  gap: 5px;
}

.patient-work-section:not(.is-closed-section) .today-queue-action,
.patient-work-section:not(.is-closed-section) .today-queue-detail-toggle {
  width: 100%;
  min-width: 0;
  min-height: 34px;
  flex: 1 1 34px;
}

.patient-work-section:not(.is-closed-section) .patient-row-details {
  grid-area: details;
  align-items: stretch;
  flex-direction: column;
  gap: 10px;
}

.patient-work-section:not(.is-closed-section) .patient-row-facts {
  width: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 12px;
}

.patient-work-section:not(.is-closed-section) .patient-row-secondary-actions {
  width: 100%;
  flex-wrap: wrap;
}

.patient-work-section:not(.is-closed-section) .patient-row-secondary-action {
  flex: 1 1 auto;
}

.worklist-progress {
  position: relative;
  z-index: 2;
  height: 2px;
  overflow: hidden;
  background: #dfe7e2;
}

.worklist-progress::after {
  display: block;
  width: 34%;
  height: 100%;
  background: var(--board-primary);
  content: "";
  animation: board-progress 850ms ease-in-out infinite;
}

.worklist-progress span {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.worklist-grid {
  display: grid;
  grid-template-columns: minmax(250px, 1.7fr) 112px 138px 150px minmax(170px, 1fr) 166px;
  align-items: center;
}

.worklist-head {
  min-height: 42px;
  border-bottom: 1px solid var(--board-border);
  background: #f5f4ef;
  color: #68736e;
  font-size: 13px;
  line-height: 17px;
  font-weight: 720;
  letter-spacing: 0.015em;
}

.worklist-head > div,
.worklist-row > .cell {
  min-width: 0;
  padding: 11px 14px;
}

.worklist-row {
  position: relative;
  min-height: 82px;
  border-bottom: 1px solid #e8e8e2;
  background: var(--board-surface);
  transition: background-color 140ms ease, box-shadow 140ms ease;
}

.worklist-row:last-child {
  border-bottom: 0;
}

.worklist-row:hover {
  background: #fbfaf6;
  box-shadow: inset 3px 0 0 #789a8d;
}

.worklist-section.is-loading .worklist-head,
.worklist-section.is-loading .worklist-body,
.worklist-section.is-loading .pagination {
  opacity: 0.58;
  pointer-events: none;
}

.worklist-row[data-status=waiting] {
  border-left: 3px solid #d79b45;
}

.worklist-row[data-status=checked_in] {
  border-left: 3px solid #6c9ac4;
}

.worklist-row[data-status=in_progress] {
  border-left: 3px solid #4d8c79;
}

.worklist-row[data-status=done] {
  border-left: 3px solid #91a097;
}

.worklist-row[data-status=cancelled] {
  border-left: 3px solid #c58e8b;
}

.patient-main {
  min-width: 0;
  gap: 8px;
}

.patient-main strong {
  overflow: hidden;
  color: var(--board-ink);
  font-size: 16px;
  line-height: 21px;
  font-weight: 760;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-cell p,
.cell-muted {
  margin: 4px 0 0;
  color: #7a837f;
  font-size: 13px;
  line-height: 18px;
  font-weight: 520;
}

.patient-cell .patient-visit-context {
  margin-top: 1px;
  color: #68746e;
  font-weight: 650;
}

.patient-identifiers {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
}

.patient-identifiers span {
  display: inline-block;
  max-width: 132px;
  overflow: hidden;
  border-radius: 5px;
  background: #f0f0eb;
  padding: 2px 6px;
  color: #68716d;
  font-size: 13px;
  line-height: 17px;
  font-weight: 620;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-value {
  display: block;
  overflow: hidden;
  color: var(--board-body);
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-label {
  display: none;
}

.actions-cell {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.start-button,
.precheck-button {
  min-width: 0;
  height: 38px;
  padding: 0 11px;
  font-size: 13px;
}

.delete-work-button {
  min-width: 0;
  height: 38px;
  border: 1px solid #e6c4c4;
  background: #fffafa;
  padding: 0 11px;
  color: #a43f3f;
  font-size: 13px;
  font-weight: 700;
}

.delete-work-button:hover:not(:disabled) {
  border-color: #d89d9d;
  background: #fff1f1;
}

.readonly-pill {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--board-border);
  border-radius: 8px;
  background: var(--board-surface-muted);
  padding: 0 10px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 16px;
  font-weight: 650;
  white-space: nowrap;
}

.status-badge {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0 8px;
  font-size: 13px;
  line-height: 17px;
  font-weight: 700;
  white-space: nowrap;
}

.status-badge::before {
  content: "";
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: currentColor;
}

.status-badge--neutral,
.status-badge--muted {
  border-color: #dde3ea;
  background: #eef2f6;
  color: #334155;
}

.status-badge--primary {
  border-color: #cdeee8;
  background: #e8f7f4;
  color: #0f766e;
}

.status-badge--info {
  border-color: #dbeafe;
  background: #eff6ff;
  color: #1d4ed8;
}

.status-badge--ai {
  border-color: #cffafe;
  background: #ecfeff;
  color: #0e7490;
}

.status-badge--success {
  border-color: #d1fae5;
  background: #ecfdf5;
  color: #047857;
}

.status-badge--warning {
  border-color: #fef3c7;
  background: #fffbeb;
  color: #b45309;
}

.status-badge--pending {
  border-color: #ffedd5;
  background: #fff7ed;
  color: #c2410c;
}

.status-badge--danger {
  border-color: #fee2e2;
  background: #fef2f2;
  color: #b91c1c;
}

.safety-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  min-height: 24px;
  padding: 3px 8px;
  border: 1px solid #e4cda9;
  border-radius: 999px;
  background: #fff9ef;
  color: #76531f;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
}

.safety-badge.is-critical {
  border-color: #e4b8b0;
  background: #fff4f2;
  color: #9d3529;
}

.duplicate-review {
  display: grid;
  gap: 10px;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #dfcda9;
  border-radius: 14px;
  background: #fffbf2;
}

.duplicate-review > div p {
  margin: 4px 0 0;
  color: #756a58;
  font-size: 13px;
}

.duplicate-candidate {
  display: grid;
  gap: 4px;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #d7d1c5;
  border-radius: 12px;
  background: #fff;
  color: #2e302d;
  text-align: left;
  cursor: pointer;
}

.duplicate-candidate:hover {
  border-color: #809786;
  background: #f8fbf8;
}

.duplicate-candidate small {
  color: #6c716b;
}

.operation-modal {
  position: fixed;
  z-index: 1200;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(31, 35, 31, 0.42);
  backdrop-filter: blur(3px);
}

.operation-dialog {
  display: grid;
  gap: 20px;
  width: min(520px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  padding: 24px;
  border: 1px solid rgba(58, 66, 59, 0.13);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(25, 31, 26, 0.22);
}

.operation-dialog header h2 {
  margin: 4px 0 0;
  color: #273029;
  font-size: 22px;
}

.operation-kicker {
  color: #6a786e;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.operation-dialog footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.delete-encounter-dialog {
  width: min(500px, 100%);
}

.delete-encounter-summary {
  display: grid;
  gap: 14px;
}

.delete-encounter-summary dl {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 14px 16px;
  border: 1px solid #e3e6df;
  border-radius: 12px;
  background: #f8f9f6;
}

.delete-encounter-summary dl > div {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 12px;
}

.delete-encounter-summary dt,
.delete-encounter-summary dd {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
}

.delete-encounter-summary dt {
  color: #737b75;
}

.delete-encounter-summary dd {
  overflow-wrap: anywhere;
  color: #313934;
  font-weight: 700;
}

.delete-encounter-summary p {
  margin: 0;
  padding: 13px 14px;
  border-radius: 10px;
  background: #fff4f4;
  color: #784040;
  font-size: 13px;
  line-height: 20px;
}

.delete-encounter-summary p strong {
  display: block;
  color: #943b3b;
}

.delete-encounter-summary small {
  color: #737b75;
  font-size: 13px;
  line-height: 18px;
}

.delete-confirm-button {
  border: 1px solid #a83f3f;
  background: #a83f3f;
  color: #fff;
}

.delete-confirm-button:hover:not(:disabled) {
  border-color: #8f3232;
  background: #8f3232;
}

.safety-review-list {
  display: grid;
  gap: 8px;
}

.safety-review-list article {
  padding: 14px;
  border: 1px solid #e5bdb6;
  border-radius: 12px;
  background: #fff6f4;
  color: #7e3028;
}

.safety-review-list p {
  margin: 5px 0 0;
  color: #74524d;
  font-size: 13px;
}

.safety-review-list article > button {
  margin-top: 9px;
  border: 0;
  background: transparent;
  padding: 0;
  color: inherit;
  font-size: 13px;
  font-weight: 750;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.billing-dialog {
  width: min(620px, 100%);
}

.schedule-dialog {
  width: min(760px, 100%);
}

.operation-form-section {
  display: grid;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e3e3dc;
}

.operation-form-section h3 {
  margin: 0;
  color: #354038;
  font-size: 15px;
}

.operation-form-section > button {
  justify-self: end;
}

.pagination {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--board-border);
  background: #faf9f5;
  padding: 11px 17px;
}

.pagination-summary {
  display: flex;
  align-items: baseline;
  gap: 5px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
  white-space: nowrap;
}

.pagination-summary strong {
  color: var(--board-ink);
  font-size: 13px;
  font-weight: 750;
}

.pagination-controls,
.page-size-control,
.pagination-nav,
.pagination-pages {
  display: flex;
  align-items: center;
}

.pagination-controls {
  gap: 14px;
}

.page-size-control {
  gap: 7px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 16px;
  font-weight: 650;
  white-space: nowrap;
}

.page-size-control select {
  min-width: 66px;
  padding: 0 8px;
}

.pagination-nav,
.pagination-pages {
  gap: 4px;
}

.pagination-nav button {
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--board-border);
  border-radius: 8px;
  background: #ffffff;
  padding: 0 7px;
  color: var(--board-body);
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
}

.pagination-nav button:hover:not(:disabled) {
  border-color: #aebbb4;
  background: var(--board-primary-soft);
  color: var(--board-primary);
}

.pagination-nav button.is-current {
  border-color: var(--board-primary);
  background: var(--board-primary);
  color: #ffffff;
}

.pagination-nav button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.pagination-nav button:disabled {
  background: #f1f1ec;
  color: #adb3af;
}

.pagination-mobile-current {
  display: none;
}

.state-panel {
  display: flex;
  min-height: 240px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

.state-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #d7e4e0;
  border-top-color: var(--board-primary);
  border-radius: 999px;
  animation: board-spin 700ms linear infinite;
}

.state-icon {
  display: inline-flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--board-border);
  border-radius: 14px;
  background: var(--board-surface-soft);
  color: #8aa09a;
}

.state-icon svg {
  width: 23px;
  height: 23px;
}

.state-panel strong {
  color: var(--board-muted);
  font-size: 13px;
  font-weight: 650;
}

.visit-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(25, 34, 30, 0.38);
  backdrop-filter: blur(2px);
  animation: board-fade-in 160ms ease-out both;
}

.precheck-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 980;
  background: rgba(22, 31, 27, 0.48);
  backdrop-filter: blur(3px);
  animation: board-fade-in 160ms ease-out both;
}

.precheck-modal {
  position: fixed;
  z-index: 990;
  top: 24px;
  bottom: 24px;
  left: 50%;
  display: flex;
  width: min(1080px, 100vw - 48px);
  overflow: hidden;
  flex-direction: column;
  border: 1px solid rgba(48, 61, 54, 0.16);
  border-radius: 18px;
  background: #f6f8f7;
  box-shadow: 0 30px 90px rgba(18, 28, 23, 0.28);
  transform: translateX(-50%);
  animation: precheck-modal-in 190ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.precheck-modal-header {
  display: flex;
  min-height: 76px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--board-border);
  background: #fffefa;
  padding: 14px 18px 14px 22px;
}

.precheck-modal-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 16px;
}

.precheck-modal-heading > span {
  display: inline-flex;
  min-height: 30px;
  flex: 0 0 auto;
  align-items: center;
  border-radius: 8px;
  background: var(--board-primary-soft);
  padding: 4px 9px;
  color: var(--board-primary);
  font-size: 13px;
  line-height: 18px;
  font-weight: 780;
}

.precheck-modal-heading > div {
  min-width: 0;
}

.precheck-modal-heading h2 {
  overflow: hidden;
  margin: 0;
  color: var(--board-ink);
  font-size: 21px;
  line-height: 27px;
  font-weight: 820;
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.precheck-modal-heading p {
  overflow: hidden;
  margin: 2px 0 0;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.precheck-modal-header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}

.precheck-modal-status {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border: 1px solid #d8dfda;
  border-radius: 999px;
  background: #f4f6f3;
  padding: 3px 9px;
  color: #59635e;
  font-size: 12px;
  line-height: 18px;
  font-weight: 720;
  white-space: nowrap;
}

.precheck-modal-close {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: #5d6762;
  cursor: pointer;
}

.precheck-modal-close svg {
  width: 22px;
  height: 22px;
}

.precheck-modal-close:hover,
.precheck-modal-close:focus-visible {
  border-color: var(--board-border);
  background: #f3f5f2;
  color: var(--board-ink);
  outline: none;
}

.precheck-modal-close:focus-visible {
  box-shadow: 0 0 0 3px var(--board-focus);
}

.precheck-modal-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  overscroll-behavior: contain;
}

.precheck-modal-body > wiz-portal-hanscribe-interview-input {
  display: block;
  min-height: 100%;
}

.precheck-discard-modal {
  padding: 16px;
  background: rgba(27, 34, 30, 0.3);
  backdrop-filter: blur(1.5px);
}

.precheck-discard-dialog {
  gap: 14px;
  width: min(390px, 100%);
  padding: 22px;
  border-color: #dfe3df;
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(24, 31, 27, 0.18);
}

.precheck-discard-header h2 {
  margin: 0;
  color: #27302b;
  font-size: 19px;
  line-height: 27px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.precheck-discard-dialog > p {
  margin: -3px 0 2px;
  color: #68716c;
  font-size: 14px;
  line-height: 21px;
}

.precheck-discard-dialog footer {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 8px;
}

.precheck-discard-dialog footer .hs-btn {
  width: 100%;
  min-width: 0;
  min-height: 42px;
  border-radius: 9px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 760;
}

.precheck-discard-confirm {
  border: 1px solid #d8deda;
  background: #ffffff;
  color: #965047;
}

.precheck-discard-confirm:hover {
  border-color: #d8b9b4;
  background: #fff7f5;
}

.precheck-discard-stay {
  border: 1px solid var(--hs-btn-primary-bg, #17483e);
  background: var(--hs-btn-primary-bg, #17483e);
  color: #ffffff;
}

.precheck-discard-stay:hover,
.precheck-discard-stay:focus-visible {
  background: var(--hs-btn-primary-bg-hover, #215e51);
  outline: none;
}

.precheck-discard-confirm:focus-visible,
.precheck-discard-stay:focus-visible {
  box-shadow: 0 0 0 3px rgba(23, 72, 62, 0.18);
}

@keyframes precheck-modal-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}
.visit-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  display: flex;
  width: min(700px, 100vw);
  flex-direction: column;
  border-left: 1px solid var(--board-border);
  background: var(--board-surface);
  box-shadow: -24px 0 54px rgba(28, 38, 33, 0.16);
  animation: board-panel-in 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.visit-panel-header,
.visit-panel-footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--board-surface);
  padding: 18px 22px;
}

.visit-panel-header {
  border-bottom: 1px solid var(--board-border);
}

.visit-panel-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
}

.visit-panel-heading > div {
  min-width: 0;
}

.visit-panel-heading > div > span {
  display: block;
  margin-bottom: 1px;
  color: var(--board-muted);
  font-size: 12px;
  line-height: 14px;
  font-weight: 700;
}

.visit-back-button {
  display: inline-flex;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--board-border-strong);
  border-radius: 9px;
  background: #ffffff;
  padding: 0 10px 0 7px;
  color: var(--board-body);
  cursor: pointer;
  font-size: 13px;
  font-weight: 730;
}

.visit-back-button svg {
  width: 18px;
  height: 18px;
}

.visit-back-button:hover:not(:disabled),
.visit-back-button:focus-visible {
  border-color: #abc0b7;
  background: var(--board-primary-soft);
  color: var(--board-primary);
  outline: none;
}

.visit-panel-header h2 {
  font-size: 22px;
  line-height: 30px;
}

.visit-panel-body {
  flex: 1 1 auto;
  overflow: auto;
  padding: 20px 22px 28px;
}

.visit-panel-body.is-type-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 64px;
}

.panel-alert {
  margin-bottom: 18px;
}

.visit-type-step {
  display: grid;
  width: 100%;
  max-width: 560px;
  gap: 28px;
  margin: 0 auto;
}

.visit-type-heading > span {
  display: block;
  margin-bottom: 3px;
  color: var(--board-primary);
  font-size: 12px;
  line-height: 16px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
}

.visit-type-heading h3,
.visit-type-heading p {
  margin: 0;
}

.visit-type-heading h3 {
  color: var(--board-ink);
  font-size: 25px;
  line-height: 34px;
  font-weight: 790;
  text-align: center;
}

.visit-type-heading p {
  margin-top: 6px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  font-weight: 560;
  text-align: center;
}

.visit-type-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.visit-type-option {
  position: relative;
  display: flex;
  width: 100%;
  aspect-ratio: 1/1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 22px;
  padding: 24px;
  color: var(--board-body);
  cursor: pointer;
  text-align: center;
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.visit-type-option[data-visit-type=first_visit] {
  border-color: #dfbd8f;
  background: linear-gradient(145deg, #fffaf2 0%, #f5e3ca 100%);
  color: #9b5f24;
  box-shadow: 0 12px 28px rgba(155, 95, 36, 0.1);
}

.visit-type-option[data-visit-type=follow_up] {
  border-color: #9fc3b5;
  background: linear-gradient(145deg, #f3faf7 0%, #dcece5 100%);
  color: #236553;
  box-shadow: 0 12px 28px rgba(35, 101, 83, 0.11);
}

.visit-type-option:hover:not(:disabled),
.visit-type-option:focus-visible {
  outline: none;
  transform: translateY(-3px);
}

.visit-type-option[data-visit-type=first_visit]:hover:not(:disabled),
.visit-type-option[data-visit-type=first_visit]:focus-visible {
  border-color: #c98b48;
  background: linear-gradient(145deg, #fff8eb 0%, #efd6b5 100%);
  box-shadow: 0 16px 34px rgba(155, 95, 36, 0.17), 0 0 0 3px rgba(201, 139, 72, 0.13);
}

.visit-type-option[data-visit-type=follow_up]:hover:not(:disabled),
.visit-type-option[data-visit-type=follow_up]:focus-visible {
  border-color: #4f907d;
  background: linear-gradient(145deg, #edf8f3 0%, #cfe5dc 100%);
  box-shadow: 0 16px 34px rgba(35, 101, 83, 0.17), 0 0 0 3px rgba(79, 144, 125, 0.13);
}

.visit-type-option.is-selected {
  box-shadow: 0 0 0 3px var(--board-focus);
}

.visit-type-copy,
.visit-type-copy strong,
.visit-type-copy small {
  position: relative;
  z-index: 1;
  display: block;
  min-width: 0;
}

.visit-type-copy::before {
  display: block;
  width: 48px;
  height: 6px;
  border-radius: 999px;
  margin: 0 auto 18px;
  background: currentColor;
  content: "";
  opacity: 0.88;
}

.visit-type-copy strong {
  color: currentColor;
  font-size: 23px;
  line-height: 30px;
  font-weight: 800;
}

.visit-type-copy small {
  margin-top: 5px;
  color: currentColor;
  opacity: 0.74;
  font-size: 13px;
  line-height: 19px;
  font-weight: 560;
}

.patient-search-control {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 94px;
  gap: 8px;
}

.patient-search-control > button {
  display: inline-flex;
  height: 46px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--board-primary);
  border-radius: 10px;
  background: var(--board-primary);
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  font-weight: 760;
}

.patient-search-control > button:hover:not(:disabled),
.patient-search-control > button:focus-visible {
  background: var(--board-primary-hover);
  outline: none;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.patient-search-control svg {
  width: 16px;
  height: 16px;
}

.patient-search-summary {
  margin: 12px 0 7px;
  color: var(--board-muted);
  font-size: 12px;
  line-height: 16px;
  font-weight: 680;
}

.patient-search-results {
  display: grid;
  max-height: 312px;
  gap: 7px;
  overflow-y: auto;
  padding-right: 3px;
  scrollbar-color: #b8c8c0 transparent;
  scrollbar-width: thin;
}

.patient-search-result {
  display: grid;
  width: 100%;
  gap: 5px;
  border: 1px solid #dde1dc;
  border-radius: 11px;
  background: #ffffff;
  padding: 11px 12px;
  color: var(--board-body);
  cursor: pointer;
  text-align: left;
}

.patient-search-result:hover:not(:disabled),
.patient-search-result:focus-visible {
  border-color: #a9bdb4;
  background: var(--board-primary-soft);
  outline: none;
}

.patient-search-result > span {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.patient-search-result strong {
  overflow: hidden;
  color: var(--board-ink);
  font-size: 14px;
  line-height: 20px;
  font-weight: 780;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-search-result em {
  flex: 0 0 auto;
  color: var(--board-primary);
  font-size: 12px;
  line-height: 16px;
  font-style: normal;
  font-weight: 720;
}

.patient-search-result small {
  color: var(--board-muted);
  font-size: 12px;
  line-height: 17px;
  font-weight: 560;
}

.patient-search-loading,
.patient-search-empty {
  border: 1px dashed #cfd8d1;
  border-radius: 11px;
  background: var(--board-surface-soft);
  padding: 18px 14px;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 18px;
  text-align: center;
}

.patient-search-empty strong,
.patient-search-empty span {
  display: block;
}

.patient-search-empty strong {
  color: var(--board-body);
  font-size: 13px;
  font-weight: 740;
}

.patient-search-empty span {
  margin-top: 2px;
}

.selected-patient-card {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 1px solid #b9cec4;
  border-radius: 13px;
  background: var(--board-primary-soft);
  padding: 13px;
}

.selected-patient-icon {
  display: inline-flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--board-primary);
  color: #ffffff;
  font-size: 15px;
  line-height: 1;
  font-weight: 850;
}

.selected-patient-card > div:nth-child(2),
.selected-patient-card > div:nth-child(2) > span,
.selected-patient-card strong,
.selected-patient-card small {
  display: block;
  min-width: 0;
}

.selected-patient-card > div:nth-child(2) > span {
  color: var(--board-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.selected-patient-card strong {
  overflow: hidden;
  color: var(--board-ink);
  font-size: 15px;
  line-height: 21px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-patient-card small {
  overflow: hidden;
  color: var(--board-muted);
  font-size: 12px;
  line-height: 17px;
  font-weight: 560;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-patient-card > button {
  min-height: 34px;
  border: 1px solid #b8c9c1;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 10px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  font-weight: 750;
}

.selected-patient-card > button:hover:not(:disabled),
.selected-patient-card > button:focus-visible {
  border-color: var(--board-primary);
  outline: none;
  box-shadow: 0 0 0 3px var(--board-focus);
}

.selected-patient-confirm {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 9px;
  border: 1px solid #cddbd4;
  border-radius: 10px;
  background: #f7fbf8;
  padding: 10px 12px;
  color: var(--board-body);
  cursor: pointer;
  font-size: 12px;
  line-height: 17px;
  font-weight: 680;
}

.selected-patient-confirm input {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: var(--board-primary);
}

.selected-patient-confirm:focus-within {
  border-color: var(--board-primary);
  box-shadow: 0 0 0 3px var(--board-focus);
}

.follow-up-notes {
  margin-top: 13px;
}

.form-section + .form-section {
  border-top: 1px solid var(--board-border);
  margin-top: 22px;
  padding-top: 22px;
}

.form-section-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 14px;
}

.form-section-heading > span {
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cdeee8;
  border-radius: 6px;
  background: var(--board-primary-soft);
  color: var(--board-primary);
  font-size: 13px;
  line-height: 1;
  font-weight: 800;
}

.form-section h3 {
  margin: 0;
  color: var(--board-ink);
  font-size: 15px;
  line-height: 20px;
  font-weight: 750;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.visit-panel .field input,
.visit-panel .field select {
  height: 46px;
  font-size: 14px;
}

.form-grid-span-2 {
  grid-column: 1/-1;
}

.form-date-picker-wrap {
  position: relative;
  width: 100%;
}

.form-date-trigger {
  display: flex;
  width: 100%;
  height: 46px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #d5d8d2;
  border-radius: 10px;
  background: #faf9f5;
  padding: 0 6px 0 12px;
  color: var(--board-ink);
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  font-weight: 650;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.form-date-trigger:hover:not(:disabled) {
  border-color: #b9c0ba;
  background: var(--board-surface);
}

.form-date-trigger[aria-expanded=true],
.form-date-trigger:focus-visible {
  border-color: var(--board-primary);
  background: var(--board-surface);
  box-shadow: 0 0 0 3px var(--board-focus);
  outline: none;
}

.form-date-trigger > span:first-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-calendar-popover {
  top: calc(100% + 7px);
  z-index: 110;
}

.form-date-picker-wrap.is-popover-up .form-calendar-popover {
  top: auto;
  bottom: calc(100% + 7px);
}

.form-date-trigger .calendar-trigger-icon,
.time-trigger-icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border: 0;
  background: transparent;
}

.time-trigger-icon,
.time-picker-heading-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--board-primary);
}

.time-trigger-icon svg,
.time-picker-heading-icon svg {
  width: 18px;
  height: 18px;
}

.form-time-picker-wrap {
  position: relative;
  width: 100%;
}

.time-picker-popover {
  position: absolute;
  right: 0;
  bottom: calc(100% + 7px);
  z-index: 115;
  width: min(330px, 100vw - 44px);
  border: 1px solid #cfd6d0;
  border-radius: 16px;
  background: #fffefa;
  padding: 13px;
  box-shadow: 0 22px 54px rgba(29, 45, 38, 0.18), 0 3px 10px rgba(29, 45, 38, 0.08);
  animation: board-calendar-in 150ms ease-out both;
}

.time-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e6e0;
  padding: 0 1px 11px;
}

.time-picker-header > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.time-picker-heading-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 9px;
  background: var(--board-primary-soft);
}

.time-picker-header strong,
.time-picker-header small {
  display: block;
}

.time-picker-header strong {
  color: var(--board-ink);
  font-size: 14px;
  line-height: 19px;
  font-weight: 780;
}

.time-picker-header small {
  color: var(--board-muted);
  font-size: 12px;
  line-height: 15px;
  font-weight: 560;
}

.time-picker-header > span {
  flex: 0 0 auto;
  border-radius: 999px;
  background: var(--board-primary-soft);
  padding: 5px 8px;
  color: var(--board-primary);
  font-size: 12px;
  line-height: 16px;
  font-weight: 760;
}

.time-option-grid {
  display: grid;
  max-height: 224px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  overflow-y: auto;
  margin-top: 10px;
  padding-right: 3px;
  scrollbar-color: #b8c8c0 transparent;
  scrollbar-width: thin;
}

.time-option {
  min-height: 36px;
  border: 1px solid #e0e4df;
  border-radius: 9px;
  background: #ffffff;
  color: var(--board-body);
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 670;
}

.time-option:hover,
.time-option:focus-visible {
  border-color: #abc0b7;
  background: var(--board-primary-soft);
  color: var(--board-primary);
  outline: none;
}

.time-option.is-selected {
  border-color: var(--board-primary);
  background: var(--board-primary);
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(23, 72, 62, 0.16);
}

.time-picker-footer {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid #e4e6e0;
  margin-top: 10px;
  padding: 10px 2px 0;
}

.time-picker-footer > span {
  min-width: 0;
  overflow: hidden;
  color: var(--board-muted);
  font-size: 13px;
  line-height: 17px;
  font-weight: 620;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.time-picker-footer > button {
  flex: 0 0 auto;
  min-height: 32px;
  border: 1px solid #c9d7d0;
  border-radius: 8px;
  background: var(--board-primary-soft);
  padding: 0 10px;
  color: var(--board-primary);
  cursor: pointer;
  font-size: 13px;
  line-height: 17px;
  font-weight: 750;
}

.time-picker-footer > button:hover,
.time-picker-footer > button:focus-visible {
  border-color: #abc0b7;
  background: #dce9e3;
  outline: none;
}

.calendar-jump-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 104px;
  gap: 7px;
  margin-bottom: 9px;
}

.visit-panel .calendar-jump-controls select {
  height: 36px;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 9px;
  font-size: 13px;
  font-weight: 700;
}

.calendar-day:disabled {
  border-color: transparent;
  background: transparent;
  color: #c6cbc8;
  cursor: not-allowed;
  box-shadow: none;
}

.phone-control {
  display: grid;
  grid-template-columns: minmax(122px, 0.42fr) minmax(0, 1fr);
  gap: 8px;
}

.visit-panel .phone-control select,
.visit-panel .phone-control input {
  width: 100%;
}

.field-help {
  color: var(--board-muted);
  font-size: 12px;
  line-height: 16px;
  font-weight: 560;
}

.visit-panel-footer {
  border-top: 1px solid var(--board-border);
  justify-content: flex-end;
  background: #f6f5f0;
}

.visit-panel-footer .ghost-button {
  min-width: 92px;
}

.visit-panel-footer .submit-visit-button {
  min-width: 138px;
  height: 44px;
}

@keyframes board-calendar-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes board-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes board-filter-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes board-progress {
  from {
    transform: translateX(-120%);
  }
  to {
    transform: translateX(360%);
  }
}
@keyframes board-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes board-panel-in {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 1260px) {
  .board-shell {
    padding: 22px;
  }
  .worklist-grid {
    grid-template-columns: minmax(200px, 1.5fr) 100px 126px 150px minmax(170px, 1fr) 156px;
  }
  .filter-grid {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }
  .filter-actions {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
}
@media (max-width: 1080px) {
  .worklist-head {
    display: none;
  }
  .worklist-body {
    display: grid;
    gap: 10px;
    background: var(--board-surface-soft);
    padding: 12px;
  }
  .worklist-row.worklist-grid {
    grid-template-columns: minmax(200px, 1.35fr) minmax(120px, 0.8fr) minmax(130px, 0.9fr) minmax(150px, 1fr);
    grid-template-areas: "patient status precheck actions" "patient updated assignee actions";
    min-height: 112px;
    gap: 9px 14px;
    border: 1px solid var(--board-border);
    border-radius: 9px;
    padding: 13px 14px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.025);
  }
  .worklist-row:hover {
    box-shadow: 0 5px 16px rgba(15, 23, 42, 0.05);
  }
  .patient-cell {
    grid-area: patient;
  }
  .status-cell {
    grid-area: status;
  }
  .precheck-cell {
    grid-area: precheck;
  }
  .updated-cell {
    grid-area: updated;
  }
  .assignee-cell {
    grid-area: assignee;
  }
  .actions-cell {
    grid-area: actions;
  }
  .worklist-row > .cell {
    padding: 0;
  }
  .status-cell,
  .precheck-cell,
  .updated-cell,
  .assignee-cell {
    min-width: 0;
  }
  .mobile-label {
    display: block;
    margin-bottom: 4px;
    color: #7b8e88;
    font-size: 13px;
    line-height: 18px;
    font-weight: 700;
  }
  .actions-cell {
    align-content: center;
    flex-direction: column;
    align-items: stretch;
  }
  .actions-cell > * {
    width: 100%;
  }
}
@media (max-width: 900px) {
  .patient-work-sections {
    grid-template-columns: minmax(0, 1fr);
  }
  .patient-work-section,
  .patient-work-section:nth-child(3) {
    border-right: 0;
    border-bottom: 1px solid var(--board-border);
  }
  .patient-work-section.is-closed-section {
    grid-column: 1;
    border-top: 0;
    border-bottom: 0;
  }
  .board-shell {
    gap: 16px;
    padding: 18px;
  }
  .board-header {
    align-items: flex-start;
  }
  .filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .filter-grid .field:last-of-type {
    grid-column: 1/-1;
  }
  .business-date-bar {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;
  }
  .business-date-main {
    width: 100%;
  }
  .business-date-picker-wrap {
    min-width: 0;
    flex: 1 1 auto;
  }
  .business-date-summary {
    justify-content: flex-start;
  }
  .appointment-row {
    grid-template-columns: 60px minmax(0, 1fr) auto;
    grid-template-areas: "time patient action" "time assignment action" "time alert action";
    row-gap: 2px;
  }
  .appointment-row time {
    grid-area: time;
  }
  .appointment-patient {
    grid-area: patient;
  }
  .appointment-assignment {
    grid-area: assignment;
  }
  .appointment-row .workflow-attention {
    grid-area: alert;
    width: fit-content;
  }
  .appointment-row .workflow-action,
  .appointment-row .workflow-readonly {
    grid-area: action;
  }
  .workflow-lanes {
    display: flex;
    gap: 1px;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
  }
  .workflow-lane {
    min-width: min(320px, 100vw - 72px);
    flex: 0 0 min(320px, 100vw - 72px);
    scroll-snap-align: start;
  }
  .today-queue-head {
    display: none;
  }
  .today-queue-row {
    grid-template-columns: 60px minmax(0, 1fr) 138px;
    grid-template-areas: "time patient action" "time state action" "time timing action" "time assignment action";
    gap: 2px 10px;
    padding: 9px 12px;
  }
  .today-queue-row time {
    grid-area: time;
    align-self: start;
    padding-top: 1px;
  }
  .today-queue-patient {
    grid-area: patient;
  }
  .today-queue-state {
    grid-area: state;
    margin-top: 3px;
  }
  .today-queue-timing {
    grid-area: timing;
    margin-top: 3px;
  }
  .today-queue-assignment {
    grid-area: assignment;
    margin-top: 1px;
  }
  .today-queue-action-cell {
    grid-area: action;
    align-self: center;
  }
  .today-queue-action {
    min-width: 0;
    flex: 1 1 auto;
  }
  .patient-row-details {
    align-items: stretch;
    flex-direction: column;
  }
  .patient-row-facts {
    width: 100%;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .patient-row-secondary-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
@media (max-width: 720px) {
  .precheck-modal {
    inset: 0;
    width: 100vw;
    border: 0;
    border-radius: 0;
    transform: none;
    animation-name: board-fade-in;
  }
  .precheck-modal-header {
    min-height: 68px;
    gap: 10px;
    padding: 10px 10px 10px 14px;
  }
  .precheck-modal-heading {
    gap: 10px;
  }
  .precheck-modal-heading > span,
  .precheck-modal-status {
    display: none;
  }
  .precheck-modal-heading h2 {
    font-size: 19px;
    line-height: 25px;
  }
  .precheck-modal-heading p {
    font-size: 12px;
    line-height: 17px;
  }
  .precheck-modal-close {
    width: 44px;
    height: 44px;
  }
  .board-shell {
    gap: 14px;
    padding: 14px 12px 24px;
  }
  .board-header {
    min-height: 48px;
    align-items: center;
    gap: 10px;
  }
  .board-heading {
    gap: 10px;
  }
  .board-heading-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 9px;
  }
  .board-heading-icon svg {
    width: 19px;
    height: 19px;
  }
  .title-block h1 {
    font-size: 21px;
    line-height: 28px;
  }
  .header-actions {
    gap: 6px;
  }
  .refresh-button {
    min-width: 44px;
    width: 44px;
    height: 44px;
    padding: 0;
  }
  .refresh-button > span {
    display: none;
  }
  .header-create-button {
    min-width: 0;
    height: 44px;
    padding: 0 11px;
    font-size: 13px;
  }
  .board-workspace {
    border-radius: 10px;
  }
  .business-date-bar {
    padding: 9px;
  }
  .business-date-main {
    display: grid;
    grid-template-columns: 40px minmax(0, 1fr) 40px 52px;
    gap: 5px;
  }
  .business-date-picker-wrap,
  .business-date-picker {
    width: 100%;
  }
  .business-date-picker {
    height: 44px;
    gap: 6px;
    padding-left: 10px;
  }
  .calendar-popover {
    left: 50%;
    width: min(320px, 100vw - 32px);
    transform: translateX(-50%);
  }
  .date-arrow {
    width: 40px;
  }
  .today-button {
    min-width: 0;
    padding: 0 7px;
  }
  .business-date-summary {
    flex-wrap: nowrap;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
  }
  .business-date-summary::-webkit-scrollbar {
    display: none;
  }
  .workspace-mode-bar {
    align-items: stretch;
    flex-direction: column;
    gap: 6px;
    padding-bottom: 9px;
  }
  .workspace-mode-switch {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .workspace-mode-switch button {
    width: 100%;
    min-width: 0;
    height: 42px;
  }
  .workspace-mode-bar > p {
    padding: 0 4px;
    text-align: left;
  }
  .status-overview {
    display: flex;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;
  }
  .status-overview::-webkit-scrollbar {
    display: none;
  }
  .overview-item {
    min-width: 112px;
    min-height: 44px;
    gap: 10px;
    padding: 8px 10px;
  }
  .overview-label {
    font-size: 13px;
  }
  .overview-item strong {
    font-size: 16px;
    line-height: 22px;
  }
  .search-panel {
    padding: 14px;
  }
  .search-main {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .search-text-field {
    grid-column: 1/-1;
  }
  .primary-query-button,
  .filter-toggle,
  .search-main > .ghost-button {
    min-width: 0;
    width: 100%;
    height: 44px;
    padding-right: 8px;
    padding-left: 8px;
    font-size: 13px;
  }
  .filter-grid,
  .form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .form-grid-span-2 {
    grid-column: auto;
  }
  .phone-control {
    grid-template-columns: minmax(112px, 0.45fr) minmax(0, 1fr);
  }
  .form-calendar-popover,
  .time-picker-popover {
    right: auto;
    left: 0;
    width: min(320px, 100vw - 44px);
  }
  .filter-grid .field:last-of-type {
    grid-column: auto;
  }
  .filter-actions {
    grid-column: auto;
  }
  .filter-actions > * {
    flex: 1 1 120px;
  }
  .field input,
  .field select {
    height: 44px;
    font-size: 16px;
  }
  .workspace-alert {
    margin: 12px 14px 0;
  }
  .carryover-alert {
    padding: 11px;
  }
  .carryover-heading {
    align-items: flex-start;
  }
  .carryover-items {
    align-items: stretch;
    flex-direction: column;
  }
  .carryover-items article {
    width: 100%;
    min-width: 0;
    flex-basis: auto;
  }
  .carryover-action {
    min-height: 36px;
  }
  .workflow-header {
    min-height: 50px;
    align-items: center;
    padding: 8px 11px;
  }
  .workflow-subsection-header {
    min-height: 40px;
    padding: 7px 10px;
  }
  .workflow-subsection-header > div {
    display: block;
  }
  .workflow-subsection-header span {
    display: none;
  }
  .appointment-row {
    grid-template-columns: 52px minmax(0, 1fr) auto;
    gap: 8px;
    padding: 9px 10px;
  }
  .appointment-assignment {
    max-width: 100%;
  }
  .workflow-empty-state {
    min-height: 210px;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    padding: 28px 18px;
    text-align: center;
  }
  .workflow-empty-state button {
    width: 100%;
    max-width: 220px;
    margin-top: 4px;
  }
  .workflow-header > p {
    max-width: 118px;
    text-align: right;
  }
  .section-title-line h2 {
    font-size: 15px;
    line-height: 21px;
  }
  .workflow-lane {
    min-width: calc(100vw - 52px);
    flex-basis: calc(100vw - 52px);
    padding: 8px;
  }
  .workflow-card {
    padding: 10px;
  }
  .workflow-action {
    min-height: 38px;
    padding-right: 9px;
    padding-left: 9px;
    font-size: 13px;
  }
  .today-queue-row {
    grid-template-columns: 52px minmax(0, 1fr) 138px;
    column-gap: 8px;
    padding: 9px 10px;
  }
  .today-queue-action {
    min-width: 0;
    min-height: 38px;
    padding: 0 7px;
  }
  .today-queue-detail-toggle {
    min-width: 58px;
    height: 38px;
    flex-basis: 58px;
  }
  .patient-row-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .patient-row-secondary-actions {
    flex-wrap: wrap;
  }
  .patient-row-secondary-action {
    min-height: 38px;
    flex: 1 1 auto;
  }
  .worklist-toolbar {
    min-height: 52px;
    align-items: center;
    padding: 11px 14px;
  }
  .patient-section-heading {
    min-height: 44px;
    padding-right: 12px;
    padding-left: 12px;
  }
  .worklist-body {
    gap: 10px;
    padding: 10px;
  }
  .worklist-row.worklist-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas: "patient patient" "status precheck" "updated assignee" "actions actions";
    min-height: 0;
    gap: 12px;
    padding: 13px;
  }
  .patient-main strong {
    font-size: 15px;
  }
  .patient-cell p,
  .cell-muted,
  .cell-value {
    overflow-wrap: anywhere;
    white-space: normal;
  }
  .actions-cell {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .actions-cell > * {
    width: 100%;
  }
  .actions-cell .readonly-pill {
    grid-column: 1/-1;
  }
  .start-button,
  .precheck-button,
  .readonly-pill {
    min-height: 42px;
    padding-right: 8px;
    padding-left: 8px;
    font-size: 13px;
  }
  .state-panel {
    min-height: 220px;
  }
  .pagination {
    min-height: 0;
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
    padding: 12px 13px 14px;
  }
  .pagination-controls {
    justify-content: space-between;
  }
  .pagination-pages,
  .pagination-edge {
    display: none;
  }
  .pagination-mobile-current {
    display: inline-flex;
    min-width: 52px;
    height: 44px;
    align-items: center;
    justify-content: center;
    color: var(--board-body);
    font-size: 13px;
    line-height: 18px;
    font-weight: 700;
  }
  .pagination-nav button {
    min-width: 44px;
    height: 44px;
  }
  .page-size-control select {
    height: 40px;
    font-size: 13px;
  }
  .visit-panel {
    left: 0;
    width: 100vw;
    border-left: 0;
  }
  .visit-panel-header,
  .visit-panel-footer {
    padding: 14px;
  }
  .visit-panel-header h2 {
    font-size: 20px;
    line-height: 28px;
  }
  .visit-panel-body {
    padding: 16px 14px 22px;
  }
  .visit-panel-body.is-type-selection {
    padding-top: 28px;
    padding-bottom: 48px;
  }
  .visit-panel-footer {
    display: grid;
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  }
  .visit-panel-footer .ghost-button,
  .visit-panel-footer .submit-visit-button {
    width: 100%;
    min-width: 0;
    height: 46px;
  }
}
@media (max-width: 420px) {
  .visit-type-step {
    gap: 22px;
  }
  .visit-type-heading h3 {
    font-size: 22px;
    line-height: 30px;
  }
  .visit-type-options {
    gap: 10px;
  }
  .visit-type-option {
    min-height: 0;
    gap: 12px;
    border-radius: 17px;
    padding: 12px 8px;
  }
  .visit-type-copy::before {
    width: 36px;
    height: 5px;
    margin-bottom: 12px;
  }
  .visit-type-copy strong {
    font-size: 19px;
    line-height: 25px;
  }
  .visit-type-copy small {
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
  }
  .patient-search-control {
    grid-template-columns: minmax(0, 1fr) 82px;
  }
  .selected-patient-card {
    grid-template-columns: 42px minmax(0, 1fr);
  }
  .selected-patient-icon {
    width: 42px;
    height: 42px;
  }
  .selected-patient-card > button {
    grid-column: 1/-1;
    width: 100%;
  }
  .board-heading-icon {
    display: none;
  }
  .header-create-button .button-icon {
    display: none;
  }
  .overview-item {
    min-width: 108px;
  }
  .search-panel {
    padding-right: 12px;
    padding-left: 12px;
  }
  .worklist-toolbar {
    padding-right: 12px;
    padding-left: 12px;
  }
  .actions-cell {
    grid-template-columns: minmax(0, 1fr);
  }
  .actions-cell > * {
    grid-column: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .filter-grid,
  .calendar-popover,
  .visit-backdrop,
  .visit-panel,
  .precheck-modal-backdrop,
  .precheck-modal,
  .state-spinner,
  .worklist-progress::after {
    animation: none !important;
  }
  .encounter-board *,
  .encounter-board *::before,
  .encounter-board *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`],
})
export class PortalHanscribeEncounterBoardComponent implements OnInit {
    private static cachedBoardResponse: any = null;
    private static cachedWorkflow: any = null;
    private readonly boardStatePrefix = 'hanscribe.encounter-board.v2';
    @Input() context: any;

    public componentId = 'encounter.board';
    public loading = true;
    public saving = false;
    public deleting = false;
    public seeding = false;
    public cleaningDemo = false;
    public creatingCleanDemo = false;
    public error = '';
    public qaMessage = '';
    public requestId = '';
    public demoFixtureEnabled = false;
    public qaFixtureEnabled = false;
    public filtersOpen = false;
    public closedRecordsOpen = false;
    public expandedEncounterId = '';
    public visitPanelOpen = false;
    public precheckModalOpen = false;
    public precheckModalDirty = false;
    public precheckDiscardReview = false;
    public precheckModalItem: BoardItem | null = null;
    public precheckModalContext: any = null;
    public duplicateReview: any = null;
    public deleteReview: BoardItem | null = null;
    public safetyReview: any = null;
    public safetyPanel: any = null;
    public billingPanel: any = null;
    public schedulePanelOpen = false;
    public schedule: any = { resources: [], providers: [] };
    public debugDetailsOpen = false;
    public calendarOpen = false;
    public calendarViewKey = '';
    public formCalendarOpen = '';
    public timePickerOpen = false;
    public formCalendarViewKeys: any = { birth: '', schedule: '' };
    public readonly calendarWeekdays = ['일', '월', '화', '수', '목', '금', '토'];
    public readonly calendarMonths = Array.from({ length: 12 }, (_, index) => ({
        value: index + 1,
        label: `${index + 1}월`,
    }));
    public readonly phonePrefixes = [
        { value: '010', label: '010' },
        { value: '011', label: '011' },
        { value: '016', label: '016' },
        { value: '017', label: '017' },
        { value: '018', label: '018' },
        { value: '019', label: '019' },
        { value: '02', label: '02 · 서울' },
        { value: '031', label: '031 · 경기' },
        { value: '032', label: '032 · 인천' },
        { value: '033', label: '033 · 강원' },
        { value: '041', label: '041 · 충남' },
        { value: '042', label: '042 · 대전' },
        { value: '043', label: '043 · 충북' },
        { value: '044', label: '044 · 세종' },
        { value: '051', label: '051 · 부산' },
        { value: '052', label: '052 · 울산' },
        { value: '053', label: '053 · 대구' },
        { value: '054', label: '054 · 경북' },
        { value: '055', label: '055 · 경남' },
        { value: '061', label: '061 · 전남' },
        { value: '062', label: '062 · 광주' },
        { value: '063', label: '063 · 전북' },
        { value: '064', label: '064 · 제주' },
        { value: '070', label: '070 · 인터넷전화' },
    ];
    public readonly reservationTimeOptions = Array.from({ length: 48 }, (_, index) => {
        const hour = Math.floor(index / 2);
        const minute = index % 2 === 0 ? '00' : '30';
        const value = `${String(hour).padStart(2, '0')}:${minute}`;
        const period = hour < 12 ? '오전' : '오후';
        const displayHour = hour % 12 || 12;
        return { value, label: `${period} ${displayHour}:${minute}` };
    });
    public doctorAccounts: any[] = [];
    public patientSearchText = '';
    public patientSearchResults: any[] = [];
    public patientSearchTotal = 0;
    public patientSearching = false;
    public patientSearchAttempted = false;
    public patientSelectionConfirmed = false;

    public page = 1;
    public dump = 100;
    public total = 0;
    public counts: any = { all: 0 };
    public overviewCounts: any = { all: 0 };
    public sectionCounts: any = { all: 0 };
    public workflow: any = {
        items: [],
        in_progress: [],
        reception: [],
        waiting: [],
        checkout: [],
        upcoming: [],
        counts: { all: 0, in_progress: 0, reception: 0, waiting: 0, checkout: 0, upcoming: 0 },
    };
    public carryover: any = { items: [], count: 0 };
    public operationsComplete = false;
    public operations: any = {
        all: 0,
        appointment: 0,
        walk_in: 0,
        first_visit: 0,
        follow_up: 0,
        general: 0,
        precheck_pending: 0,
        cancelled: 0,
    };
    public items: BoardItem[] = [];

    public filters: any = {
        text: '',
        date: this.todayDateKey(),
        doctor_id: '',
    };

    public form: any = {
        patient_id: '',
        display_name: '',
        patient_no: '',
        birth_date: '',
        sex_code: '',
        phone_prefix: '010',
        phone_number: '',
        phone: '',
        phone_last4: '',
        encounter_no: '',
        status: 'waiting',
        purpose_code: 'care_support',
        encounter_type: '',
        assigned_doctor_id: '',
        assigned_doctor_name: '',
        department_code: '',
        room_code: '',
        scheduled_date: this.todayDateKey(),
        scheduled_time: this.defaultScheduledTime(),
        scheduled_at: '',
        precheck_status: 'pending',
        duration_minutes: 30,
        resource_id: '',
        allow_duplicate: false,
        duplicate_override_reason: '',
        safety_label: '',
        safety_severity: 'caution',
        safety_requires_ack: false,
    };
    public billingForm: any = {
        insurance_type: 'nhis',
        coverage_status: 'unchecked',
        gross_amount: 0,
        covered_amount: 0,
        patient_due: 0,
        amount: 0,
        method: 'card',
    };
    public resourceForm: any = {
        resource_code: '',
        resource_name: '',
        resource_type: 'room',
        capacity: 1,
        active: true,
    };
    public safetyForm: any = { label: '', detail: '', severity: 'caution', requires_ack: false, flag_type: 'other' };
    public providerScheduleForm: any = {
        provider_id: '',
        provider_name: '',
        work_date: this.todayDateKey(),
        start_time: '09:00',
        end_time: '18:00',
        schedule_status: 'working',
        slot_minutes: 30,
    };

    public clinicBase = '/hanscribe/clinic';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.restoreBoardState();
        this.resolveContext();
        if (!this.filters.date) this.filters.date = this.todayDateKey();
        await this.loadBoard();
    }

    public get busy() {
        return this.loading || this.saving || this.deleting || this.seeding || this.cleaningDemo || this.creatingCleanDemo || this.patientSearching;
    }

    public get empty() {
        return !this.loading && this.items.length === 0;
    }

    public get currentRole() {
        return this.service.auth.session?.role || '';
    }

    public get currentUserId() {
        return String(this.service.auth.session?.id || '');
    }

    public get canCreateVisit() {
        return hanscribeCan(this.currentRole, 'board_create_visit');
    }

    public get canDeleteVisit() {
        return hanscribeCan(this.currentRole, 'board_delete_visit');
    }

    public get canSeedDemoFixtures() {
        return hanscribeCan(this.currentRole, 'demo_fixture_seed') && this.demoFixtureEnabled;
    }

    public get canCleanupDemoWorkspace() {
        return hanscribeCan(this.currentRole, 'demo_fixture_create_clean') && this.demoFixtureEnabled;
    }

    public get canViewDebugDetails() {
        return this.qaFixtureEnabled || this.isDevMode() || this.queryValue('debug') === '1';
    }

    public get canStartEncounter() {
        return hanscribeCan(this.currentRole, 'board_start_encounter');
    }

    public canStartEncounterItem(item: BoardItem) {
        return this.canStartEncounter
            && this.currentUserId !== ''
            && String(item?.assigned_doctor_id || '') === this.currentUserId;
    }

    public get waitingTotal() {
        return (Number(this.counts.waiting) || 0) + (Number(this.counts.checked_in) || 0);
    }

    public get unifiedBoardItems() {
        const priority: any = this.currentRole === 'doctor'
            ? { in_progress: 0, waiting: 1, checked_in: 2, scheduled: 3, checkout_pending: 4, done: 5, cancelled: 6, no_show: 7, left_without_care: 8 }
            : { checked_in: 0, checkout_pending: 1, waiting: 2, scheduled: 3, in_progress: 4, done: 5, cancelled: 6, no_show: 7, left_without_care: 8 };
        return this.items
            .slice()
            .sort((left, right) => {
                const leftPriority = Number(priority[String(left.status || '')] ?? 99);
                const rightPriority = Number(priority[String(right.status || '')] ?? 99);
                if (leftPriority !== rightPriority) return leftPriority - rightPriority;
                return this.workflowSortTime(left, ['checked_in_at', 'ended_at', 'started_at', 'scheduled_at', 'created'])
                    - this.workflowSortTime(right, ['checked_in_at', 'ended_at', 'started_at', 'scheduled_at', 'created']);
            });
    }

    public get patientSections() {
        const items = this.unifiedBoardItems;
        const definitions = [
            { key: 'intake', label: '접수·예진', statuses: ['scheduled', 'checked_in'], collapsible: false },
            { key: 'care', label: '진료', statuses: ['waiting', 'in_progress'], collapsible: false },
            { key: 'checkout', label: '수납', statuses: ['checkout_pending'], collapsible: false },
            { key: 'closed', label: '종료 기록', statuses: ['done', 'cancelled', 'no_show', 'left_without_care'], collapsible: true },
        ];
        return definitions.map((section) => ({
            ...section,
            count: section.statuses.reduce((total, status) => total + Number(this.sectionCounts[status] || 0), 0),
            items: items.filter((item) => section.statuses.includes(String(item.status || ''))),
        }));
    }

    public get selectedDateLabel() {
        const date = this.dateFromKey(this.filters.date);
        if (!date) return '진료일 선택';
        const parts = new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
        }).format(date);
        return this.isSelectedToday ? `오늘 · ${parts}` : parts;
    }

    public get calendarMonthLabel() {
        const anchor = this.dateFromKey(`${this.activeCalendarViewKey()}-01`);
        if (!anchor) return '';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: 'long',
        }).format(anchor);
    }

    public get calendarSelectionLabel() {
        const date = this.dateFromKey(this.filters.date);
        if (!date) return '날짜를 선택해주세요.';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
        }).format(date);
    }

    public get calendarDays() {
        const viewKey = this.activeCalendarViewKey();
        const first = this.dateFromKey(`${viewKey}-01`);
        if (!first) return [];
        const start = new Date(first.getTime());
        start.setUTCDate(start.getUTCDate() - start.getUTCDay());
        const selectedKey = String(this.filters.date || '').slice(0, 10);
        const todayKey = this.todayDateKey();

        return Array.from({ length: 42 }, (_, index) => {
            const date = new Date(start.getTime());
            date.setUTCDate(start.getUTCDate() + index);
            const dateKey = this.dateKeyFromDate(date);
            const today = dateKey === todayKey;
            const selected = dateKey === selectedKey;
            const label = new Intl.DateTimeFormat('ko-KR', {
                timeZone: 'Asia/Seoul',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
            }).format(date);
            const states = [today ? '오늘' : '', selected ? '선택됨' : ''].filter(Boolean);

            return {
                dateKey,
                day: date.getUTCDate(),
                currentMonth: dateKey.slice(0, 7) === viewKey,
                today,
                selected,
                ariaLabel: states.length ? `${label}, ${states.join(', ')}` : label,
            };
        });
    }

    public formDateLabel(kind: string) {
        const value = this.formDateValue(kind);
        const date = this.dateFromKey(value);
        if (!date) return kind === 'birth' ? '생년월일 선택' : '예약일 선택';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
        }).format(date);
    }

    public formCalendarMonthLabel(kind: string) {
        const anchor = this.dateFromKey(`${this.activeFormCalendarViewKey(kind)}-01`);
        if (!anchor) return '';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: 'long',
        }).format(anchor);
    }

    public formCalendarYear(kind: string) {
        return Number(this.activeFormCalendarViewKey(kind).slice(0, 4));
    }

    public formCalendarMonth(kind: string) {
        return Number(this.activeFormCalendarViewKey(kind).slice(5, 7));
    }

    public formCalendarYears(kind: string) {
        const currentYear = Number(this.todayDateKey().slice(0, 4));
        const selectedYear = this.formCalendarYear(kind);
        const start = kind === 'birth' ? currentYear - 120 : currentYear - 1;
        const end = kind === 'birth' ? currentYear : currentYear + 5;
        const years = Array.from({ length: end - start + 1 }, (_, index) => start + index);
        if (selectedYear < start || selectedYear > end) years.push(selectedYear);
        years.sort((left, right) => kind === 'birth' ? right - left : left - right);
        return years;
    }

    public calendarDaysFor(kind: string) {
        const viewKey = this.activeFormCalendarViewKey(kind);
        const first = this.dateFromKey(`${viewKey}-01`);
        if (!first) return [];
        const start = new Date(first.getTime());
        start.setUTCDate(start.getUTCDate() - start.getUTCDay());
        const selectedKey = this.formDateValue(kind);
        const todayKey = this.todayDateKey();

        return Array.from({ length: 42 }, (_, index) => {
            const date = new Date(start.getTime());
            date.setUTCDate(start.getUTCDate() + index);
            const dateKey = this.dateKeyFromDate(date);
            const today = dateKey === todayKey;
            const selected = dateKey === selectedKey;
            const label = new Intl.DateTimeFormat('ko-KR', {
                timeZone: 'Asia/Seoul',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                weekday: 'long',
            }).format(date);
            const states = [today ? '오늘' : '', selected ? '선택됨' : ''].filter(Boolean);
            return {
                dateKey,
                day: date.getUTCDate(),
                currentMonth: dateKey.slice(0, 7) === viewKey,
                today,
                selected,
                future: dateKey > todayKey,
                ariaLabel: states.length ? `${label}, ${states.join(', ')}` : label,
            };
        });
    }

    public get scheduledTimeLabel() {
        const value = String(this.form.scheduled_time || '').slice(0, 5);
        const selected = this.reservationTimeOptions.find((option) => option.value === value);
        return selected?.label || value || '예약 시간 선택';
    }

    public formatPhoneNumber(value: any) {
        const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
        if (digits.length <= 4) {
            this.form.phone_number = digits;
            return;
        }
        const middleLength = digits.length <= 7 ? 3 : 4;
        this.form.phone_number = `${digits.slice(0, middleLength)}-${digits.slice(middleLength)}`;
    }

    public doctorAccountLabel(doctor: any) {
        const context = [doctor.department, doctor.organization].filter(Boolean).join(' · ');
        return context ? `${doctor.name} · ${context}` : (doctor.name || doctor.email || '한의사');
    }

    public async syncSelectedDoctor() {
        const selected = this.doctorAccounts.find((doctor) => doctor.id === this.form.assigned_doctor_id);
        this.form.assigned_doctor_name = selected?.name || '';
        await this.service.render();
    }

    public get isSelectedToday() {
        return this.filters.date === this.todayDateKey();
    }

    public get activeFilterCount() {
        return ['text', 'doctor_id'].filter((key) => String(this.filters[key] || '').trim()).length;
    }

    public get hasActiveFilters() {
        return this.activeFilterCount > 0;
    }

    public get doctorFilterLabel() {
        const selected = this.doctorAccounts.find((doctor) => doctor.id === this.filters.doctor_id);
        return selected ? this.doctorAccountLabel(selected) : String(this.filters.doctor_id || '');
    }

    public get totalPages() {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public get pageStart() {
        if (!this.total || !this.items.length) return 0;
        return ((this.page - 1) * this.dump) + 1;
    }

    public get pageEnd() {
        if (!this.total || !this.items.length) return 0;
        return Math.min(this.page * this.dump, this.total);
    }

    public get pageNumbers() {
        const pages: number[] = [];
        const start = Math.max(1, Math.min(this.page - 2, this.totalPages - 4));
        const end = Math.min(this.totalPages, start + 4);
        for (let page = start; page <= end; page += 1) pages.push(page);
        return pages;
    }

    public async loadBoard(page: number = this.page) {
        this.loading = true;
        this.expandedEncounterId = '';
        this.error = '';
        this.qaMessage = '';
        this.demoFixtureEnabled = false;
        this.qaFixtureEnabled = false;
        this.page = Math.max(1, Number(page) || 1);
        await this.service.render();

        const payload = {
            text: this.filters.text,
            date: this.filters.date,
            doctor_id: this.filters.doctor_id,
            page: this.page,
            dump: this.dump,
        };
        let result = await this.callApi('load_board', payload);
        if (!result.ok && this.shouldRetryBoard(result)) {
            await this.wait(240);
            result = await this.callApi('load_board', payload);
        }

        this.loading = false;
        if (result.ok) {
            Component.cachedBoardResponse = result.data;
            this.applyBoardData(result.data);
            if (this.total > 0 && this.page > this.totalPages) {
                this.loading = false;
                await this.loadBoard(this.totalPages);
                return;
            }
            this.persistBoardState();
        } else if (Component.cachedBoardResponse) {
            this.applyBoardData(Component.cachedBoardResponse);
            this.qaMessage = '최근 조회 결과를 표시하고 있습니다.';
        } else {
            this.error = result.message;
        }
        await this.service.render();
    }

    public async toggleFilters() {
        this.filtersOpen = !this.filtersOpen;
        this.persistBoardState();
        await this.service.render();
    }

    public async toggleClosedRecords() {
        if (this.busy) return;
        this.closedRecordsOpen = !this.closedRecordsOpen;
        await this.service.render();
    }

    public async moveBusinessDate(days: number) {
        if (this.busy) return;
        const current = this.dateFromKey(this.filters.date) || this.dateFromKey(this.todayDateKey());
        if (!current) return;
        current.setUTCDate(current.getUTCDate() + Number(days || 0));
        await this.applyBusinessDate(this.dateKeyFromDate(current));
    }

    public async goToToday() {
        if (this.busy || this.isSelectedToday) return;
        await this.applyBusinessDate(this.todayDateKey());
    }

    public async toggleCalendar(event?: Event) {
        if (event) event.stopPropagation();
        if (this.busy) return;
        this.calendarOpen = !this.calendarOpen;
        this.formCalendarOpen = '';
        if (this.calendarOpen) {
            this.calendarViewKey = this.validMonthKey(this.filters.date) || this.todayDateKey().slice(0, 7);
        }
        await this.service.render();
        if (this.calendarOpen) this.focusCalendarDate();
    }

    public keepCalendarOpen(event: Event) {
        event.stopPropagation();
    }

    public async moveCalendarMonth(months: number, event?: Event) {
        if (event) event.stopPropagation();
        const first = this.dateFromKey(`${this.activeCalendarViewKey()}-01`);
        if (!first) return;
        first.setUTCMonth(first.getUTCMonth() + Number(months || 0));
        this.calendarViewKey = this.dateKeyFromDate(first).slice(0, 7);
        await this.service.render();
    }

    public async selectCalendarDate(dateKey: string, event?: Event) {
        if (event) event.stopPropagation();
        const normalized = String(dateKey || '').slice(0, 10);
        if (!this.dateFromKey(normalized)) return;
        this.calendarOpen = false;
        if (normalized === this.filters.date) {
            await this.service.render();
            this.focusCalendarTrigger();
            return;
        }
        await this.applyBusinessDate(normalized);
        this.focusCalendarTrigger();
    }

    public async selectCalendarToday(event?: Event) {
        if (event) event.stopPropagation();
        await this.selectCalendarDate(this.todayDateKey());
    }

    public async toggleFormCalendar(kind: string, event?: Event) {
        if (event) event.stopPropagation();
        if (this.busy) return;
        const opening = this.formCalendarOpen !== kind;
        this.formCalendarOpen = opening ? kind : '';
        this.timePickerOpen = false;
        this.calendarOpen = false;
        if (opening) {
            const selected = this.formDateValue(kind);
            this.formCalendarViewKeys[kind] = this.validMonthKey(selected) || this.todayDateKey().slice(0, 7);
        }
        await this.service.render();
        if (opening) this.focusFormCalendarDate(kind);
    }

    public async moveFormCalendarMonth(kind: string, months: number, event?: Event) {
        if (event) event.stopPropagation();
        const first = this.dateFromKey(`${this.activeFormCalendarViewKey(kind)}-01`);
        if (!first) return;
        first.setUTCMonth(first.getUTCMonth() + Number(months || 0));
        this.formCalendarViewKeys[kind] = this.dateKeyFromDate(first).slice(0, 7);
        await this.service.render();
    }

    public async setFormCalendarYear(kind: string, year: any) {
        const normalizedYear = Number(year);
        if (!Number.isInteger(normalizedYear) || normalizedYear < 1900 || normalizedYear > 2100) return;
        const month = this.formCalendarMonth(kind);
        this.formCalendarViewKeys[kind] = `${normalizedYear}-${this.padNumber(month)}`;
        await this.service.render();
    }

    public async setFormCalendarMonth(kind: string, month: any) {
        const normalizedMonth = Number(month);
        if (!Number.isInteger(normalizedMonth) || normalizedMonth < 1 || normalizedMonth > 12) return;
        const year = this.formCalendarYear(kind);
        this.formCalendarViewKeys[kind] = `${year}-${this.padNumber(normalizedMonth)}`;
        await this.service.render();
    }

    public async selectFormCalendarDate(kind: string, dateKey: string, event?: Event) {
        if (event) event.stopPropagation();
        const normalized = String(dateKey || '').slice(0, 10);
        if (!this.dateFromKey(normalized)) return;
        if (kind === 'birth' && normalized > this.todayDateKey()) return;
        this.setFormDateValue(kind, normalized);
        this.formCalendarOpen = '';
        await this.service.render();
        this.focusFormCalendarTrigger(kind);
    }

    public async selectFormCalendarToday(kind: string, event?: Event) {
        if (event) event.stopPropagation();
        await this.selectFormCalendarDate(kind, this.todayDateKey());
    }

    public async clearFormDate(kind: string, event?: Event) {
        if (event) event.stopPropagation();
        this.setFormDateValue(kind, '');
        this.formCalendarOpen = '';
        await this.service.render();
        this.focusFormCalendarTrigger(kind);
    }

    public async toggleTimePicker(event?: Event) {
        if (event) event.stopPropagation();
        if (this.busy) return;
        const opening = !this.timePickerOpen;
        this.timePickerOpen = opening;
        this.calendarOpen = false;
        this.formCalendarOpen = '';
        await this.service.render();
        if (opening) this.focusTimePickerOption();
    }

    public async selectReservationTime(value: string, event?: Event) {
        if (event) event.stopPropagation();
        const normalized = String(value || '').slice(0, 5);
        if (!/^\d{2}:\d{2}$/.test(normalized)) return;
        this.form.scheduled_time = normalized;
        this.timePickerOpen = false;
        await this.service.render();
        this.focusTimePickerTrigger();
    }

    public async selectCurrentReservationTime(event?: Event) {
        if (event) event.stopPropagation();
        await this.selectReservationTime(this.defaultScheduledTime());
    }

    @HostListener('document:click')
    public async closeCalendarFromOutside() {
        if (!this.calendarOpen && !this.formCalendarOpen && !this.timePickerOpen) return;
        this.calendarOpen = false;
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        await this.service.render();
    }

    @HostListener('document:keydown', ['$event'])
    public async handleCalendarKeyboard(event: KeyboardEvent) {
        if (event.key !== 'Escape') return;
        if (this.precheckDiscardReview) {
            event.preventDefault();
            await this.cancelDiscardPrecheckModal();
            return;
        }
        if (this.precheckModalOpen) {
            event.preventDefault();
            await this.requestClosePrecheckModal();
            return;
        }
        if (!this.calendarOpen && !this.formCalendarOpen && !this.timePickerOpen) return;
        event.preventDefault();
        const boardWasOpen = this.calendarOpen;
        const formKind = this.formCalendarOpen;
        const timeWasOpen = this.timePickerOpen;
        this.calendarOpen = false;
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        await this.service.render();
        if (boardWasOpen) this.focusCalendarTrigger();
        else if (formKind) this.focusFormCalendarTrigger(formKind);
        else if (timeWasOpen) this.focusTimePickerTrigger();
    }

    public async clearFilter(key: string) {
        if (!Object.prototype.hasOwnProperty.call(this.filters, key)) return;
        this.filters[key] = key === 'date' ? this.todayDateKey() : '';
        await this.loadBoard(1);
    }

    public async changeDump() {
        this.dump = [20, 50, 100].includes(Number(this.dump)) ? Number(this.dump) : 20;
        await this.loadBoard(1);
    }

    public async goToPage(page: number) {
        const target = Math.min(Math.max(1, Number(page) || 1), this.totalPages);
        if (this.busy || target === this.page) return;
        await this.loadBoard(target);
        this.scrollToWorklist();
    }

    public async selectVisitType(type: string) {
        if (this.busy || !['first_visit', 'follow_up'].includes(type)) return;
        if (this.form.encounter_type === type) return;
        this.clearVisitPatient();
        this.form.encounter_type = type;
        this.error = '';
        this.duplicateReview = null;
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        this.patientSearchText = '';
        this.patientSearchResults = [];
        this.patientSearchTotal = 0;
        this.patientSearchAttempted = false;
        await this.service.render();
        this.scrollVisitPanelTop();
        if (type === 'follow_up') await this.searchPatients();
    }

    public async changeVisitType() {
        if (this.busy) return;
        this.clearVisitPatient();
        this.form.encounter_type = '';
        this.error = '';
        this.duplicateReview = null;
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        this.patientSearchText = '';
        this.patientSearchResults = [];
        this.patientSearchTotal = 0;
        this.patientSearchAttempted = false;
        await this.service.render();
        this.scrollVisitPanelTop();
    }

    public async searchPatients() {
        if (this.form.encounter_type !== 'follow_up' || this.patientSearching) return;
        this.patientSearching = true;
        this.patientSearchAttempted = true;
        this.error = '';
        await this.service.render();
        const result = await this.callApi('search_patients', {
            text: String(this.patientSearchText || '').trim(),
            dump: 12,
        });
        this.patientSearching = false;
        if (result.ok) {
            const search = result.data?.result || {};
            this.patientSearchResults = Array.isArray(search.rows) ? search.rows : [];
            this.patientSearchTotal = Number(search.total || 0);
        } else {
            this.patientSearchResults = [];
            this.patientSearchTotal = 0;
            this.error = result.message;
        }
        await this.service.render();
    }

    public async selectExistingPatient(patient: any) {
        if (this.busy || !patient?.id) return;
        this.form.patient_id = patient.id;
        this.form.display_name = patient.display_name || '';
        this.form.patient_no = patient.patient_no || '';
        this.form.birth_date = patient.birth_date || '';
        this.form.sex_code = patient.sex_code || '';
        this.form.phone = '';
        this.form.phone_last4 = patient.phone_last4 || '';
        this.patientSelectionConfirmed = false;
        this.error = '';
        await this.service.render();
    }

    public async setPatientSelectionConfirmed(event: any) {
        this.patientSelectionConfirmed = event && event.target ? event.target.checked === true : event === true;
        await this.service.render();
    }

    public async clearExistingPatient() {
        if (this.busy) return;
        this.clearVisitPatient();
        await this.service.render();
    }

    public patientSearchMeta(patient: any) {
        const labels: any = { F: '여성', M: '남성', U: '미상' };
        const sex = labels[String(patient?.sex_code || '')] || '성별 미입력';
        const birth = patient?.birth_date || '생년월일 미입력';
        const phone = patient?.phone_last4 ? `연락처 ···· ${patient.phone_last4}` : '연락처 미입력';
        return `${birth} · ${sex} · ${phone}`;
    }

    public async openVisitPanel() {
        if (!this.canCreateVisit) {
            this.error = '방문 생성 권한이 없습니다.';
            await this.service.render();
            return;
        }
        this.error = '';
        this.resetForm();
        await this.refreshDoctorAccounts();
        this.ensureVisitFormDefaults();
        this.visitPanelOpen = true;
        await this.service.render();
    }

    public async closeVisitPanel() {
        this.visitPanelOpen = false;
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        this.duplicateReview = null;
        this.patientSearchText = '';
        this.patientSearchResults = [];
        this.patientSearchTotal = 0;
        this.patientSearchAttempted = false;
        await this.service.render();
    }

    public async toggleDebugDetails() {
        if (!this.canViewDebugDetails) return;
        this.debugDetailsOpen = !this.debugDetailsOpen;
        await this.service.render();
    }

    public async createVisit() {
        if (!this.canCreateVisit) {
            this.error = '방문 생성 권한이 없습니다.';
            await this.service.render();
            return;
        }
        if (!['first_visit', 'follow_up'].includes(String(this.form.encounter_type || ''))) {
            this.error = '초진 또는 재진을 선택해주세요.';
            await this.service.render();
            return;
        }
        if (this.form.encounter_type === 'first_visit' && !String(this.form.display_name || '').trim()) {
            this.error = '신규 환자명을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (this.form.encounter_type === 'follow_up' && !String(this.form.patient_id || '').trim()) {
            this.error = '재진할 기존 환자를 선택해주세요.';
            await this.service.render();
            return;
        }
        if (this.form.encounter_type === 'follow_up' && !this.patientSelectionConfirmed) {
            this.error = '선택한 환자의 이름·생년월일·차트번호를 확인해주세요.';
            await this.service.render();
            return;
        }
        if (!String(this.form.assigned_doctor_id || '').trim()) {
            this.error = '담당 한의사를 선택해주세요.';
            await this.service.render();
            return;
        }
        const phone = this.composePhone();
        if (this.form.encounter_type === 'first_visit' && this.form.phone_number && (phone.length < 9 || phone.length > 11)) {
            this.error = '연락처를 앞자리 포함 9~11자리로 입력해주세요.';
            await this.service.render();
            return;
        }
        if (!String(this.form.scheduled_date || '').trim() || !String(this.form.scheduled_time || '').trim()) {
            this.error = '예약 날짜와 시간을 입력해주세요.';
            await this.service.render();
            return;
        }

        this.saving = true;
        this.error = '';
        await this.service.render();

        const result = await this.callApi('create_patient_encounter', this.visitPayload());
        this.saving = false;

        if (result.ok) {
            if (result.data?.status === 'duplicate_review') {
                this.duplicateReview = result.data.duplicate_review || result.data.patient?.duplicates || null;
                this.error = '';
                await this.service.render();
                return;
            }
            if (String(this.form.safety_label || '').trim()) {
                const patientId = result.data?.patient?.patient_id || result.data?.patient?.patient?.id || this.form.patient_id;
                const encounterId = result.data?.encounter?.encounter_id || result.data?.encounter?.encounter?.id || '';
                const safety = await this.callApi('save_safety_flag', {
                    patient_id: patientId,
                    encounter_id: encounterId,
                    label: this.form.safety_label,
                    severity: this.form.safety_severity,
                    requires_ack: this.form.safety_requires_ack || this.form.safety_severity === 'critical',
                    flag_type: 'other',
                });
                if (!safety.ok) {
                    this.error = safety.message;
                    await this.service.render();
                    return;
                }
            }
            this.resetForm();
            this.visitPanelOpen = false;
            await this.loadBoard(1);
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public async useExistingPatient(candidate: any) {
        const patient = candidate?.patient || {};
        this.form.encounter_type = 'follow_up';
        this.form.patient_id = patient.id || '';
        this.form.display_name = patient.display_name || this.form.display_name;
        this.form.patient_no = patient.patient_no || this.form.patient_no;
        this.form.birth_date = patient.birth_date || this.form.birth_date;
        this.form.sex_code = patient.sex_code || this.form.sex_code;
        this.form.allow_duplicate = false;
        this.form.duplicate_override_reason = '';
        this.duplicateReview = null;
        await this.createVisit();
    }

    public async createDuplicateAnyway() {
        if (String(this.form.duplicate_override_reason || '').trim().length < 5) {
            this.error = '신규 환자로 등록하는 사유를 5자 이상 입력해주세요.';
            await this.service.render();
            return;
        }
        this.form.allow_duplicate = true;
        this.duplicateReview = null;
        await this.createVisit();
    }

    public async seedDemoFixtures() {
        if (!this.canSeedDemoFixtures) {
            this.error = '시연 데이터 준비 권한이 없습니다.';
            await this.service.render();
            return;
        }
        this.seeding = true;
        this.error = '';
        this.qaMessage = '';
        await this.service.render();

        const result = await this.callApi('seed_demo_fixtures', {});
        this.seeding = false;
        if (result.ok) {
            const payload = result.data && result.data.result ? result.data.result : result.data;
            const count = payload.scenario_count || 0;
            this.filters.text = payload.query_text || '정다은';
            await this.loadBoard(1);
            this.qaMessage = `시연 데이터 ${count}건이 준비되었습니다.`;
            await this.service.render();
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public async cleanupDemoWorkspace() {
        if (!this.canCleanupDemoWorkspace) {
            this.error = '시연 화면 정리 권한이 없습니다.';
            await this.service.render();
            return;
        }
        this.cleaningDemo = true;
        this.error = '';
        this.qaMessage = '';
        await this.service.render();

        const result = await this.callApi('cleanup_demo_workspace', {});
        this.cleaningDemo = false;
        if (result.ok) {
            const payload = result.data && result.data.result ? result.data.result : result.data;
            const removed = Number((payload.cleanup && payload.cleanup.encounter) || 0);
            const resetCount = Number(payload.reset_count || 0);
            this.filters.text = 'HS-20260626';
            await this.loadBoard(1);
            this.qaMessage = `시연 화면 정리 완료: ${resetCount}건 초기화, 이전 시연 ${removed}건 삭제.`;
            await this.service.render();
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public async createCleanDemoVisit() {
        if (!this.canCleanupDemoWorkspace) {
            this.error = '시연 방문 생성 권한이 없습니다.';
            await this.service.render();
            return;
        }
        this.creatingCleanDemo = true;
        this.error = '';
        this.qaMessage = '';
        await this.service.render();

        const result = await this.callApi('create_clean_demo_visit', {});
        this.creatingCleanDemo = false;
        if (result.ok) {
            const payload = result.data && result.data.result ? result.data.result : result.data;
            this.filters.text = payload.patient_no || 'DEMO-HS';
            await this.loadBoard(1);
            this.qaMessage = `깨끗한 시연 방문이 생성되었습니다.`;
            await this.service.render();
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public async startEncounter(item: BoardItem) {
        if (!this.canStartEncounterItem(item)) {
            this.error = '본인 담당 방문만 진료를 시작할 수 있습니다.';
            await this.service.render();
            return;
        }
        const encounterId = this.encounterId(item);
        if (!encounterId) {
            this.error = '시작할 방문 ID가 없습니다.';
            await this.service.render();
            return;
        }
        if (item.status === 'in_progress') {
            this.service.href(`${this.clinicBase}/${encounterId}`);
            return;
        }

        this.saving = true;
        this.error = '';
        await this.service.render();

        const result = await this.callApi('start_encounter', { encounter_id: encounterId });
        this.saving = false;

        if (result.ok) {
            const payload = result.data && result.data.result ? result.data.result : result.data;
            if (payload.status === 'safety_confirmation_required') {
                this.safetyReview = { item, payload };
                await this.service.render();
                return;
            }
            const url = payload.clinic_url || `${this.clinicBase}/${payload.encounter_id || encounterId}`;
            await this.service.render();
            this.service.href(url);
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public async acknowledgeSafetyAndStart() {
        const review = this.safetyReview;
        if (!review) return;
        const blocking = review.payload?.safety?.blocking || [];
        this.saving = true;
        for (const flag of blocking) {
            const result = await this.callApi('acknowledge_safety', {
                flag_id: flag.id,
                encounter_id: this.encounterId(review.item),
            });
            if (!result.ok) {
                this.saving = false;
                this.error = result.message;
                await this.service.render();
                return;
            }
        }
        this.saving = false;
        this.safetyReview = null;
        await this.startEncounter(review.item);
    }

    public async closeSafetyReview() {
        if (this.busy) return;
        this.safetyReview = null;
        await this.service.render();
    }

    public async openSafetyPanel(item: BoardItem) {
        this.safetyPanel = item;
        this.safetyForm = { label: '', detail: '', severity: 'caution', requires_ack: false, flag_type: 'other' };
        await this.service.render();
    }

    public async closeSafetyPanel() {
        this.safetyPanel = null;
        await this.service.render();
    }

    public async saveSafetyFlag() {
        if (!this.safetyPanel) return;
        const result = await this.callApi('save_safety_flag', {
            patient_id: this.safetyPanel.patient_id || this.safetyPanel.patient?.id,
            encounter_id: this.encounterId(this.safetyPanel),
            ...this.safetyForm,
            requires_ack: this.safetyForm.requires_ack || this.safetyForm.severity === 'critical',
        });
        if (!result.ok) {
            this.error = result.message;
            await this.service.render();
            return;
        }
        this.safetyPanel = null;
        await this.loadBoard(this.page);
    }

    public async resolveSafetyFlag(flag: any) {
        const reason = String(window.prompt('특이사항 해제 사유를 입력해주세요.') || '').trim();
        if (reason.length < 3) return;
        const result = await this.callApi('resolve_safety_flag', { flag_id: flag.id, reason });
        if (!result.ok) {
            this.error = result.message;
            await this.service.render();
            return;
        }
        this.safetyPanel = null;
        await this.loadBoard(this.page);
    }

    public async transitionEncounter(item: BoardItem, target: string) {
        let reason = '';
        if (['cancelled', 'no_show', 'left_without_care', 'scheduled'].includes(target)) {
            reason = String(window.prompt('상태 변경 사유를 입력해주세요.') || '').trim();
            if (reason.length < 3) return;
        }
        this.saving = true;
        const result = await this.callApi('transition_encounter', {
            encounter_id: this.encounterId(item),
            target_status: target,
            reason: reason || this.transitionLabel(target),
        });
        this.saving = false;
        if (result.ok) {
            const payload = result.data?.result || result.data;
            if (payload.status === 'billing_required') {
                await this.openBillingPanel(item);
                return;
            }
            await this.loadBoard(this.page);
            return;
        }
        this.error = result.message;
        await this.service.render();
    }

    public canDeleteEncounter(item: BoardItem) {
        const allowedStatuses = ['scheduled', 'waiting', 'checked_in', 'cancelled', 'no_show'];
        return this.canDeleteVisit
            && allowedStatuses.includes(String(item?.status || ''))
            && !item?.started_at
            && !item?.ended_at
            && !item?.current_draft_id
            && !item?.final_chart_id;
    }

    public async openDeleteEncounter(item: BoardItem) {
        if (!this.canDeleteEncounter(item) || this.busy) return;
        this.error = '';
        this.deleteReview = item;
        await this.service.render();
    }

    public async closeDeleteEncounter() {
        if (this.deleting) return;
        this.deleteReview = null;
        await this.service.render();
    }

    public async confirmDeleteEncounter() {
        const item = this.deleteReview;
        if (!item || !this.canDeleteEncounter(item) || this.deleting) return;
        const encounterId = this.encounterId(item);
        if (!encounterId) {
            this.error = '삭제할 방문 ID가 없습니다.';
            await this.service.render();
            return;
        }

        const patientName = String(item.patient_name || '선택한 환자');
        this.deleting = true;
        this.error = '';
        this.qaMessage = '';
        await this.service.render();
        const result = await this.callApi('delete_encounter', {
            encounter_id: encounterId,
            reason: '환자/방문 보드에서 업무 삭제',
        });
        this.deleting = false;
        if (!result.ok) {
            this.error = result.message;
            await this.service.render();
            return;
        }

        this.deleteReview = null;
        Component.cachedBoardResponse = null;
        Component.cachedWorkflow = null;
        await this.loadBoard(this.page);
        this.qaMessage = `${patientName}님의 방문 업무를 삭제했습니다. 환자 정보는 유지됩니다.`;
        await this.service.render();
    }

    public transitionLabel(status: string) {
        const labels: any = {
            checked_in: '접수',
            waiting: '진료 대기 등록',
            in_progress: '진료 시작',
            checkout_pending: '진료 완료',
            done: '수납 완료',
            cancelled: '취소',
            no_show: '미내원',
            left_without_care: '진료 전 귀가',
            scheduled: '예약 복원',
        };
        return labels[status] || status;
    }

    public primaryTransition(item: BoardItem) {
        const priorities = this.currentRole === 'doctor'
            ? ['in_progress', 'checkout_pending']
            : ['checked_in', 'waiting', 'done'];
        return priorities.find((status) => (item.allowed_transitions || []).includes(status)) || '';
    }

    public rowDetailsOpen(item: BoardItem) {
        return this.expandedEncounterId === this.encounterId(item);
    }

    public async toggleRowDetails(item: BoardItem) {
        const encounterId = this.encounterId(item);
        if (!encounterId) return;
        this.expandedEncounterId = this.expandedEncounterId === encounterId ? '' : encounterId;
        await this.service.render();
    }

    public queueStatusLabel(item: BoardItem) {
        const labels: any = {
            scheduled: '접수 전',
            checked_in: '접수·예진',
            waiting: '진료 대기',
            in_progress: '진료 중',
            checkout_pending: '수납 대기',
        };
        return labels[String(item?.status || '')] || this.statusLabel(item?.status || '');
    }

    public queueStatusClass(item: BoardItem) {
        const status = ['scheduled', 'checked_in', 'waiting', 'in_progress', 'checkout_pending', 'done', 'cancelled', 'no_show', 'left_without_care']
            .includes(String(item?.status || '')) ? String(item.status) : 'unknown';
        return `queue-status queue-status--${status}`;
    }

    public queueActionLabel(item: BoardItem) {
        const status = String(item?.status || '');
        if (this.currentRole !== 'doctor' && this.canCreateVisit) {
            if (status === 'scheduled' && (item.allowed_transitions || []).includes('checked_in')) return '접수';
            if (['checked_in', 'waiting'].includes(status) && !item.precheck_submitted && this.encounterId(item)) return '예진 입력';
            if (status === 'checked_in' && (item.allowed_transitions || []).includes('waiting')) return '진료 대기';
            if (status === 'checkout_pending' && (item.allowed_transitions || []).includes('done')) return '수납 처리';
        }
        if (this.canStartEncounterItem(item) && ['checked_in', 'waiting', 'in_progress'].includes(status)) {
            return this.encounterActionLabel(item);
        }
        return '';
    }

    public async runQueueAction(item: BoardItem) {
        const label = this.queueActionLabel(item);
        const encounterId = this.encounterId(item);
        if (!label || this.busy) return;
        if (label === '예진 입력') {
            await this.openPrecheckModal(item);
            return;
        }
        if (label === '접수') {
            await this.transitionEncounter(item, 'checked_in');
            if (!this.billingPanel) this.focusQueueAction(encounterId);
            return;
        }
        if (label === '진료 대기') {
            await this.transitionEncounter(item, 'waiting');
            if (!this.billingPanel) this.focusQueueAction(encounterId);
            return;
        }
        if (label === '수납 처리') {
            await this.transitionEncounter(item, 'done');
            if (!this.billingPanel) this.focusQueueAction(encounterId);
            return;
        }
        await this.startEncounter(item);
    }

    public async openPrecheckModal(item: BoardItem) {
        if (!this.canCreateVisit || this.busy) return;
        const encounterId = this.encounterId(item);
        if (!encounterId) {
            this.error = '예진을 입력할 방문 ID가 없습니다.';
            await this.service.render();
            return;
        }

        this.error = '';
        this.qaMessage = '';
        this.precheckModalItem = item;
        this.precheckModalDirty = false;
        this.precheckDiscardReview = false;
        this.precheckModalContext = {
            encounter_id: encounterId,
            source_channel: 'operator',
            entry_mode: 'operator',
            embedded: true,
            onClose: () => this.requestClosePrecheckModal(),
            onDirtyChange: (dirty: boolean) => {
                this.precheckModalDirty = !!dirty;
            },
            onSubmitted: () => this.completePrecheckModal(),
        };
        this.precheckModalOpen = true;
        await this.service.render();
        this.focusPrecheckModal();
    }

    public async requestClosePrecheckModal() {
        if (!this.precheckModalOpen) return;
        if (this.precheckModalDirty) {
            this.precheckDiscardReview = true;
            await this.service.render();
            this.focusPrecheckDiscardReview();
            return;
        }
        await this.closePrecheckModal();
    }

    public async cancelDiscardPrecheckModal() {
        this.precheckDiscardReview = false;
        await this.service.render();
        this.focusPrecheckModal();
    }

    public async confirmDiscardPrecheckModal() {
        this.precheckDiscardReview = false;
        this.precheckModalDirty = false;
        await this.closePrecheckModal();
    }

    public async closePrecheckModal() {
        this.precheckModalOpen = false;
        this.precheckModalDirty = false;
        this.precheckDiscardReview = false;
        this.precheckModalItem = null;
        this.precheckModalContext = null;
        await this.service.render();
    }

    public async completePrecheckModal() {
        const patientName = String(this.precheckModalItem?.patient_name || '선택한 환자');
        this.precheckModalOpen = false;
        this.precheckModalDirty = false;
        this.precheckDiscardReview = false;
        this.precheckModalItem = null;
        this.precheckModalContext = null;
        Component.cachedBoardResponse = null;
        Component.cachedWorkflow = null;
        await this.loadBoard(this.page);
        this.qaMessage = `${patientName}님의 예진을 저장했습니다.`;
        await this.service.render();
    }

    public appointmentTime(item: BoardItem) {
        return this.timeOnly(item?.scheduled_at || item?.checked_in_at || item?.created) || '시간 미정';
    }

    public async openBillingPanel(item: BoardItem) {
        const billing = item.billing || {};
        this.billingPanel = item;
        this.billingForm = {
            insurance_type: billing.insurance_type || 'nhis',
            coverage_status: billing.coverage_status || 'unchecked',
            gross_amount: Number(billing.gross_amount || 0),
            covered_amount: Number(billing.covered_amount || 0),
            patient_due: Number(billing.patient_due || 0),
            amount: Math.max(0, Number(billing.patient_due || 0) - Number(billing.paid_amount || 0)),
            method: 'card',
        };
        await this.service.render();
    }

    public async closeBillingPanel() {
        this.billingPanel = null;
        await this.service.render();
    }

    public async saveBillingAndPayment() {
        if (!this.billingPanel) return;
        const encounterId = this.encounterId(this.billingPanel);
        this.saving = true;
        const saved = await this.callApi('save_billing_case', { encounter_id: encounterId, ...this.billingForm });
        if (!saved.ok) {
            this.saving = false;
            this.error = saved.message;
            await this.service.render();
            return;
        }
        if (Number(this.billingForm.amount || 0) > 0) {
            const payment = await this.callApi('record_payment', {
                encounter_id: encounterId,
                amount: this.billingForm.amount,
                method: this.billingForm.method,
            });
            if (!payment.ok) {
                this.saving = false;
                this.error = payment.message;
                await this.service.render();
                return;
            }
        }
        const done = await this.callApi('transition_encounter', {
            encounter_id: encounterId,
            target_status: 'done',
            reason: '수납 완료',
        });
        this.saving = false;
        if (!done.ok) {
            this.error = done.message;
            await this.service.render();
            return;
        }
        this.billingPanel = null;
        await this.loadBoard(this.page);
    }

    public async openSchedulePanel() {
        if (this.currentRole !== 'admin') return;
        this.schedulePanelOpen = true;
        this.providerScheduleForm.work_date = this.filters.date || this.todayDateKey();
        await this.service.render();
    }

    public async closeSchedulePanel() {
        this.schedulePanelOpen = false;
        await this.service.render();
    }

    public async saveResource() {
        this.saving = true;
        const result = await this.callApi('save_clinic_resource', this.resourceForm);
        this.saving = false;
        if (!result.ok) {
            this.error = result.message;
            await this.service.render();
            return;
        }
        this.resourceForm = { resource_code: '', resource_name: '', resource_type: 'room', capacity: 1, active: true };
        await this.loadBoard(this.page);
        this.schedulePanelOpen = true;
    }

    public async saveProviderSchedule() {
        this.saving = true;
        const result = await this.callApi('save_provider_schedule', this.providerScheduleForm);
        this.saving = false;
        if (!result.ok) {
            this.error = result.message;
            await this.service.render();
            return;
        }
        await this.loadBoard(this.page);
        this.schedulePanelOpen = true;
    }

    public async clearFilters() {
        this.filters = { text: '', date: this.todayDateKey(), doctor_id: '' };
        Component.cachedWorkflow = null;
        await this.loadBoard(1);
    }

    public statusLabel(status: string) {
        const labels: any = {
            scheduled: '접수 전 예약',
            waiting: '대기',
            checked_in: '접수',
            in_progress: '진료 중',
            done: '완료',
            checkout_pending: '수납 대기',
            cancelled: '취소',
            no_show: '미내원',
            left_without_care: '진료 전 귀가',
        };
        return labels[status] || status || '미정';
    }

    public statusBadgeClass(status: string) {
        return hanscribeStatusBadgeClass(status, 'encounter', 'status-badge');
    }

    public precheckLabel(item: BoardItem) {
        return item.precheck_submitted ? '예진 제출됨' : '예진 미제출';
    }

    public precheckBadgeClass(item: BoardItem) {
        return hanscribePrecheckBadgeClass(item.precheck_submitted, 'status-badge');
    }

    public precheckActionLabel(item: BoardItem) {
        return item.precheck_submitted ? '예진 보기' : '예진 입력';
    }

    public safetyLabel(item: BoardItem) {
        const count = Number(item.safety?.count || 0);
        if (!count) return '';
        if (item.safety?.level === 'critical') return `중요 특이사항 ${count}`;
        return `특이사항 ${count}`;
    }

    public resourceName(resource: any) {
        return resource.resource_name || resource.resource_code || '진료 자원';
    }

    public encounterActionLabel(item: BoardItem) {
        return item.status === 'in_progress' ? '진료 계속' : '진료 시작';
    }

    public workflowTiming(item: BoardItem) {
        const status = String(item.status || '');
        if (!this.isSelectedToday) {
            const time = this.timeOnly(item.scheduled_at || item.checked_in_at || item.started_at);
            return time ? `예약 ${time}` : this.statusLabel(status);
        }
        if (status === 'in_progress') {
            return this.elapsedLabel(item.started_at || item.checked_in_at || item.scheduled_at, '진료');
        }
        if (status === 'checked_in') {
            return this.elapsedLabel(item.checked_in_at || item.scheduled_at, '접수 후');
        }
        if (status === 'waiting') {
            return this.elapsedLabel(item.checked_in_at || item.scheduled_at, '대기');
        }
        if (status === 'checkout_pending') {
            return this.elapsedLabel(item.ended_at || item.started_at || item.checked_in_at, '진료 종료 후');
        }
        if (status === 'done') {
            const time = this.timeOnly(item.ended_at || this.updatedAt(item));
            return time ? `${time} 완료` : '완료';
        }
        if (['cancelled', 'no_show', 'left_without_care'].includes(status)) {
            const time = this.timeOnly(this.updatedAt(item));
            return time ? `${time} 변경` : this.statusLabel(status);
        }
        return this.relativeScheduleLabel(item.scheduled_at, '접수 전 예약');
    }

    public workflowMeta(item: BoardItem) {
        const parts = [this.assignedPerson(item), item.room_code].filter((value) => String(value || '').trim());
        return parts.join(' · ') || '담당 미정';
    }

    public workflowPatientMeta(item: BoardItem) {
        return `${this.patientBirthSex(item)} · ${this.visitTypeLabel(item)} · ${this.arrivalTypeLabel(item)}`;
    }

    public visitTypeLabel(item: BoardItem) {
        const labels: any = {
            first_visit: '초진',
            follow_up: '재진',
            outpatient: '일반',
        };
        return labels[String(item.encounter_type || '')] || '일반';
    }

    public arrivalTypeLabel(item: BoardItem) {
        return item.scheduled_at ? '예약' : '현장';
    }

    public carryoverDateLabel(item: BoardItem) {
        const value = item.scheduled_at || item.checked_in_at || item.started_at || item.created;
        const raw = String(value || '');
        if (raw.length < 10) return '이전 진료일';
        return `${raw.slice(5, 7)}.${raw.slice(8, 10)} 미종결`;
    }

    public encounterId(item: BoardItem) {
        return item.encounter_id || item.id || '';
    }

    public visibleEncounterNo(item: BoardItem) {
        return item.encounter_no || item.external_appointment_ref || '';
    }

    public patientNumber(item: BoardItem) {
        return (item.patient && item.patient.patient_no) || item.patient_no || '';
    }

    public patientBirthSex(item: BoardItem) {
        const patient = item.patient || {};
        const birth = patient.birth_date || item.birth_date || '생년월일 없음';
        const sex = this.sexLabel(patient.sex_code || item.sex_code || '');
        return `${birth} / ${sex}`;
    }

    public assignedPerson(item: BoardItem) {
        return item.assigned_doctor_name || '';
    }

    public updatedAt(item: BoardItem) {
        return item.recent_updated_at || item.updated || item.created || '';
    }

    public formatDateTime(value: any) {
        const raw = String(value || '').trim();
        if (!raw) return '';
        const date = this.parseDate(raw);
        if (!date) return raw;
        const parts = this.koreaDateTimeParts(date);
        const dateKey = `${parts.year}-${parts.month}-${parts.day}`;
        const sameDay = dateKey === this.todayDateKey();
        const time = `${parts.hour}:${parts.minute}`;
        if (sameDay) return `오늘 ${time}`;
        return `${parts.month}.${parts.day} ${time}`;
    }

    private sexLabel(value: string) {
        const labels: any = {
            F: '여',
            M: '남',
            U: '미상',
        };
        return labels[value] || value || '성별 없음';
    }

    private padNumber(value: number) {
        return String(value).padStart(2, '0');
    }

    private async applyBusinessDate(date: string) {
        this.calendarOpen = false;
        this.closedRecordsOpen = false;
        this.filters.date = date;
        this.calendarViewKey = String(date || '').slice(0, 7);
        this.page = 1;
        Component.cachedWorkflow = null;
        await this.loadBoard(1);
    }

    private activeCalendarViewKey() {
        return this.validMonthKey(this.calendarViewKey)
            || this.validMonthKey(this.filters.date)
            || this.todayDateKey().slice(0, 7);
    }

    private activeFormCalendarViewKey(kind: string) {
        return this.validMonthKey(this.formCalendarViewKeys[kind])
            || this.validMonthKey(this.formDateValue(kind))
            || this.todayDateKey().slice(0, 7);
    }

    private formDateValue(kind: string) {
        return String(kind === 'birth' ? this.form.birth_date : this.form.scheduled_date || '').slice(0, 10);
    }

    private setFormDateValue(kind: string, value: string) {
        if (kind === 'birth') this.form.birth_date = value;
        else this.form.scheduled_date = value;
        this.formCalendarViewKeys[kind] = this.validMonthKey(value) || this.todayDateKey().slice(0, 7);
    }

    private validMonthKey(value: any) {
        const key = String(value || '').slice(0, 7);
        return /^\d{4}-\d{2}$/.test(key) ? key : '';
    }

    private focusCalendarDate() {
        setTimeout(() => {
            const selected = document.getElementById(`board-calendar-day-${this.filters.date}`);
            const first = document.querySelector<HTMLElement>('.calendar-day:not(.is-outside-month)');
            (selected || first)?.focus();
        }, 0);
    }

    private focusCalendarTrigger() {
        setTimeout(() => document.getElementById('board-calendar-trigger')?.focus(), 0);
    }

    private focusFormCalendarDate(kind: string) {
        setTimeout(() => {
            const selected = document.getElementById(`visit-${kind}-calendar-day-${this.formDateValue(kind)}`);
            const first = document.querySelector<HTMLElement>(`#visit-${kind}-calendar-popover .calendar-day:not(.is-outside-month):not(:disabled)`);
            (selected || first)?.focus();
        }, 0);
    }

    private focusFormCalendarTrigger(kind: string) {
        setTimeout(() => document.getElementById(`visit-${kind}-calendar-trigger`)?.focus(), 0);
    }

    private focusTimePickerOption() {
        setTimeout(() => {
            const selected = document.getElementById(`visit-time-option-${String(this.form.scheduled_time || '').replace(':', '-')}`);
            const first = document.querySelector<HTMLElement>('#visit-time-picker-popover .time-option');
            (selected || first)?.focus();
        }, 0);
    }

    private focusTimePickerTrigger() {
        setTimeout(() => document.getElementById('visit-time-picker-trigger')?.focus(), 0);
    }

    private focusQueueAction(encounterId: string) {
        setTimeout(() => {
            const actions = Array.from(document.querySelectorAll('[data-queue-action-id]')) as HTMLElement[];
            const target = actions.find((action) => action.getAttribute('data-queue-action-id') === encounterId)
                || actions[0];
            target?.focus();
        }, 0);
    }

    private focusPrecheckModal() {
        setTimeout(() => {
            try {
                const target = document.querySelector('[data-testid="board-precheck-close"]') as HTMLElement;
                if (target) target.focus();
            } catch (e) {
                // Focus support is optional in embedded/test environments.
            }
        }, 0);
    }

    private focusPrecheckDiscardReview() {
        setTimeout(() => {
            try {
                const target = document.querySelector('[data-testid="board-precheck-discard-cancel"]') as HTMLElement;
                if (target) target.focus();
            } catch (e) {
                // Focus support is optional in embedded/test environments.
            }
        }, 0);
    }

    private todayDateKey() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).formatToParts(new Date());
        const values: any = {};
        parts.forEach((part) => {
            if (part.type !== 'literal') values[part.type] = part.value;
        });
        return `${values.year}-${values.month}-${values.day}`;
    }

    private dateFromKey(value: any) {
        const key = String(value || '').slice(0, 10);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(key)) return null;
        const date = new Date(`${key}T00:00:00Z`);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    private dateKeyFromDate(date: Date) {
        return `${date.getUTCFullYear()}-${this.padNumber(date.getUTCMonth() + 1)}-${this.padNumber(date.getUTCDate())}`;
    }

    private timeOnly(value: any) {
        const date = this.parseDate(value);
        if (!date) return '';
        const parts = this.koreaDateTimeParts(date);
        return `${parts.hour}:${parts.minute}`;
    }

    private elapsedLabel(value: any, prefix: string) {
        const date = this.parseDate(value);
        if (!date) return prefix;
        const minutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
        return `${prefix} ${this.durationLabel(minutes)}`;
    }

    private relativeScheduleLabel(value: any, fallback: string) {
        const date = this.parseDate(value);
        if (!date) return fallback;
        const minutes = Math.round((date.getTime() - Date.now()) / 60000);
        if (minutes > 0) return `예약 ${this.durationLabel(minutes)} 전`;
        if (minutes < 0) return `${this.durationLabel(Math.abs(minutes))} 지연`;
        return '예약 시각';
    }

    private durationLabel(minutes: number) {
        const safeMinutes = Math.max(0, Math.floor(Number(minutes) || 0));
        if (safeMinutes < 60) return `${safeMinutes}분`;
        if (safeMinutes >= 1440) {
            const days = Math.floor(safeMinutes / 1440);
            const hours = Math.floor((safeMinutes % 1440) / 60);
            return hours ? `${days}일 ${hours}시간` : `${days}일`;
        }
        const hours = Math.floor(safeMinutes / 60);
        const rest = safeMinutes % 60;
        return rest ? `${hours}시간 ${rest}분` : `${hours}시간`;
    }

    private parseDate(value: any) {
        const raw = String(value || '').trim();
        if (!raw) return null;
        let normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized)
            && !/(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized)) {
            normalized = `${normalized}+09:00`;
        }
        const date = new Date(normalized);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    private koreaDateTimeParts(date: Date) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
        }).formatToParts(date);
        const values: any = {};
        parts.forEach((part) => {
            if (part.type !== 'literal') values[part.type] = part.value;
        });
        return values;
    }

    private boardStateKey() {
        const userId = this.service.auth.session?.id || this.currentRole || 'anonymous';
        return `${this.boardStatePrefix}.${userId}`;
    }

    private restoreBoardState() {
        try {
            const raw = window.sessionStorage.getItem(this.boardStateKey());
            if (!raw) return;
            const state = JSON.parse(raw);
            if (state.filters && typeof state.filters === 'object') {
                this.filters = { ...this.filters, ...state.filters };
            }
            const dump = Number(state.dump || 100);
            this.dump = [20, 50, 100].includes(dump) ? dump : 100;
            this.page = Math.max(1, Number(state.page) || 1);
            this.filtersOpen = Boolean(state.filtersOpen);
        } catch (e) {
            return;
        }
    }

    private persistBoardState() {
        try {
            window.sessionStorage.setItem(this.boardStateKey(), JSON.stringify({
                filters: this.filters,
                filtersOpen: this.filtersOpen,
                page: this.page,
                dump: this.dump,
            }));
        } catch (e) {
            return;
        }
    }

    private scrollToWorklist() {
        try {
            document.querySelector('.worklist-section')?.scrollIntoView({ block: 'start' });
        } catch (e) {
            return;
        }
    }

    private scrollVisitPanelTop() {
        try {
            const body = document.querySelector<HTMLElement>('.visit-panel-body');
            body?.scrollTo({ top: 0, behavior: 'auto' });
        } catch (e) {
            return;
        }
    }

    private resolveContext() {
        if (!this.context || typeof this.context !== 'object') return;
        this.clinicBase = this.context.clinicBase || this.context.clinic_base || this.clinicBase;
        if (this.context.filters && typeof this.context.filters === 'object') {
            this.filters = { ...this.filters, ...this.context.filters };
        }
    }

    private resetForm() {
        this.patientSelectionConfirmed = false;
        this.form = {
            patient_id: '',
            display_name: '',
            patient_no: '',
            birth_date: '',
            sex_code: '',
            phone_prefix: '010',
            phone_number: '',
            phone: '',
            phone_last4: '',
            encounter_no: '',
            status: 'waiting',
            purpose_code: 'care_support',
            encounter_type: '',
            assigned_doctor_id: '',
            assigned_doctor_name: '',
            department_code: '',
            room_code: '',
            scheduled_date: this.todayDateKey(),
            scheduled_time: this.defaultScheduledTime(),
            scheduled_at: '',
            precheck_status: 'pending',
            duration_minutes: 30,
            resource_id: '',
            allow_duplicate: false,
            duplicate_override_reason: '',
            safety_label: '',
            safety_severity: 'caution',
            safety_requires_ack: false,
        };
        this.formCalendarOpen = '';
        this.timePickerOpen = false;
        this.duplicateReview = null;
        this.patientSearchText = '';
        this.patientSearchResults = [];
        this.patientSearchTotal = 0;
        this.patientSearchAttempted = false;
        this.ensureVisitFormDefaults();
    }

    private clearVisitPatient() {
        this.patientSelectionConfirmed = false;
        this.form.patient_id = '';
        this.form.display_name = '';
        this.form.patient_no = '';
        this.form.birth_date = '';
        this.form.sex_code = '';
        this.form.phone_prefix = '010';
        this.form.phone_number = '';
        this.form.phone = '';
        this.form.phone_last4 = '';
        this.form.allow_duplicate = false;
        this.form.duplicate_override_reason = '';
        this.form.safety_label = '';
        this.form.safety_severity = 'caution';
        this.form.safety_requires_ack = false;
    }

    private ensureVisitFormDefaults() {
        this.form.phone_prefix = this.form.phone_prefix || '010';
        this.form.scheduled_date = this.form.scheduled_date || this.todayDateKey();
        this.form.scheduled_time = this.form.scheduled_time || this.defaultScheduledTime();
        if (!this.form.assigned_doctor_id && this.doctorAccounts.length === 1) {
            this.form.assigned_doctor_id = this.doctorAccounts[0].id;
            this.form.assigned_doctor_name = this.doctorAccounts[0].name;
        }
    }

    private composePhone() {
        const prefix = String(this.form.phone_prefix || '').replace(/\D/g, '');
        const number = String(this.form.phone_number || '').replace(/\D/g, '');
        return number ? `${prefix}${number}` : '';
    }

    private composeScheduledAt() {
        const date = String(this.form.scheduled_date || '').slice(0, 10);
        const time = String(this.form.scheduled_time || '').slice(0, 5);
        return date && time ? `${date}T${time}` : '';
    }

    private visitPayload() {
        const phone = this.composePhone();
        return {
            ...this.form,
            phone,
            phone_last4: phone ? phone.slice(-4) : '',
            scheduled_at: this.composeScheduledAt(),
        };
    }

    private defaultScheduledTime() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
        }).formatToParts(new Date());
        const values: any = {};
        parts.forEach((part) => {
            if (part.type !== 'literal') values[part.type] = part.value;
        });
        const total = (Number(values.hour || 9) * 60) + Number(values.minute || 0);
        const rounded = Math.min(23 * 60 + 30, Math.ceil(total / 30) * 30);
        return `${this.padNumber(Math.floor(rounded / 60))}:${this.padNumber(rounded % 60)}`;
    }

    private isDevMode() {
        try {
            return document.cookie.split(';').some((item) => item.trim() === 'season-wiz-devmode=true')
                || window.localStorage.getItem('hanscribe_debug') === 'true';
        } catch (e) {
            return false;
        }
    }

    private queryValue(key: string) {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return params.get(key) || '';
        } catch (e) {
            return '';
        }
    }

    private async refreshDoctorAccounts() {
        const result = await this.callApi('load_doctor_accounts');
        if (result.ok) {
            this.doctorAccounts = Array.isArray(result.data?.doctor_accounts) ? result.data.doctor_accounts : [];
            return;
        }
        if (!this.doctorAccounts.length) this.error = result.message;
    }

    private async callApi(action: string, payload: any = {}) {
        try {
            const response: any = await wiz.call(action, payload);
            const result = this.unwrapResponse(response);
            this.requestId = result.requestId || this.requestId;
            return result;
        } catch (e) {
            return { ok: false, data: null, requestId: '', message: '요청 처리 중 오류가 발생했습니다.', retryable: true };
        }
    }

    private wait(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    private shouldRetryBoard(result: any) {
        if (result && result.retryable) return true;
        const message = String((result && result.message) || '');
        return message === '환자/방문 보드를 불러오지 못했습니다.'
            || message === '요청 처리 중 오류가 발생했습니다.';
    }

    private applyBoardData(data: any) {
        const board = data && data.board ? data.board : (data || {});
        this.demoFixtureEnabled = data && data.demo_fixture_enabled === true;
        this.qaFixtureEnabled = data && data.qa_fixture_enabled === true;
        this.items = board.items || [];
        this.total = board.total || 0;
        this.counts = board.counts || { all: this.total };
        this.sectionCounts = board.filtered_counts || this.counts;
        this.carryover = board.carryover || { items: [], count: 0 };
        this.operationsComplete = Boolean(board.operations) || this.items.length === this.total;
        this.operations = board.operations || this.buildOperationalSummary(this.items);
        this.schedule = board.schedule || { resources: [], providers: [] };
        this.doctorAccounts = data?.doctor_accounts || [];
        this.ensureVisitFormDefaults();
        const serverWorkflow = board.workflow && board.workflow.counts ? board.workflow : null;
        const fallbackWorkflow = this.buildWorkflow(this.items, this.counts);
        if (serverWorkflow) {
            this.workflow = serverWorkflow;
            Component.cachedWorkflow = serverWorkflow;
        } else if (fallbackWorkflow.counts.all > 0 && !Component.cachedWorkflow) {
            this.workflow = fallbackWorkflow;
            Component.cachedWorkflow = fallbackWorkflow;
        } else if (Component.cachedWorkflow) {
            this.workflow = Component.cachedWorkflow;
        } else {
            this.workflow = fallbackWorkflow;
        }
        this.overviewCounts = { ...this.counts };
    }

    private buildWorkflow(items: BoardItem[], counts: any) {
        const source = Array.isArray(items) ? items.slice() : [];
        const inProgress = source
            .filter((item) => item.status === 'in_progress')
            .sort((left, right) => this.workflowSortTime(left, ['started_at', 'checked_in_at', 'scheduled_at', 'created'])
                - this.workflowSortTime(right, ['started_at', 'checked_in_at', 'scheduled_at', 'created']));
        const reception = source
            .filter((item) => item.status === 'checked_in')
            .sort((left, right) => this.workflowSortTime(left, ['checked_in_at', 'scheduled_at', 'created'])
                - this.workflowSortTime(right, ['checked_in_at', 'scheduled_at', 'created']));
        const waiting = source
            .filter((item) => item.status === 'waiting')
            .sort((left, right) => this.workflowSortTime(left, ['checked_in_at', 'scheduled_at', 'created'])
                - this.workflowSortTime(right, ['checked_in_at', 'scheduled_at', 'created']));
        const checkout = source
            .filter((item) => item.status === 'checkout_pending')
            .sort((left, right) => this.workflowSortTime(left, ['ended_at', 'started_at', 'checked_in_at', 'created'])
                - this.workflowSortTime(right, ['ended_at', 'started_at', 'checked_in_at', 'created']));
        const upcoming = source
            .filter((item) => item.status === 'scheduled')
            .sort((left, right) => this.workflowSortTime(left, ['scheduled_at', 'created'])
                - this.workflowSortTime(right, ['scheduled_at', 'created']));
        const priority: any = { checked_in: 0, checkout_pending: 1, waiting: 2, in_progress: 3, scheduled: 4 };
        const active = source
            .filter((item) => Object.prototype.hasOwnProperty.call(priority, String(item.status || '')))
            .sort((left, right) => {
                const statusDifference = priority[String(left.status || '')] - priority[String(right.status || '')];
                if (statusDifference !== 0) return statusDifference;
                return this.workflowSortTime(left, ['checked_in_at', 'ended_at', 'started_at', 'scheduled_at', 'created'])
                    - this.workflowSortTime(right, ['checked_in_at', 'ended_at', 'started_at', 'scheduled_at', 'created']);
            });
        const laneCounts = {
            in_progress: Number(counts?.in_progress || inProgress.length),
            reception: Number(counts?.checked_in || reception.length),
            waiting: Number(counts?.waiting || waiting.length),
            checkout: Number(counts?.checkout_pending || checkout.length),
            upcoming: Number(counts?.scheduled || upcoming.length),
        };
        return {
            items: active.slice(0, 50),
            in_progress: inProgress.slice(0, 50),
            reception: reception.slice(0, 50),
            waiting: waiting.slice(0, 50),
            checkout: checkout.slice(0, 50),
            upcoming: upcoming.slice(0, 50),
            counts: {
                ...laneCounts,
                all: laneCounts.in_progress + laneCounts.reception + laneCounts.waiting + laneCounts.checkout + laneCounts.upcoming,
            },
            limit: 50,
        };
    }

    private workflowSortTime(item: BoardItem, fields: string[]) {
        for (const field of fields) {
            const date = this.parseDate(item[field]);
            if (date) return date.getTime();
        }
        return Number.MAX_SAFE_INTEGER;
    }

    private buildOperationalSummary(items: BoardItem[]) {
        const summary: any = {
            all: 0,
            appointment: 0,
            walk_in: 0,
            first_visit: 0,
            follow_up: 0,
            general: 0,
            precheck_pending: 0,
            cancelled: 0,
        };
        (Array.isArray(items) ? items : []).forEach((item) => {
            summary.all += 1;
            summary[item.scheduled_at ? 'appointment' : 'walk_in'] += 1;
            const visitType = ['first_visit', 'follow_up'].includes(item.encounter_type)
                ? item.encounter_type
                : 'general';
            summary[visitType] += 1;
            if (!item.precheck_submitted) summary.precheck_pending += 1;
            if (item.status === 'cancelled') summary.cancelled += 1;
        });
        return summary;
    }

    private unwrapResponse(response: any) {
        const payload = response && response.responseJSON ? response.responseJSON : response;
        const nested = payload && payload.data && payload.data.ok !== undefined ? payload.data : payload;
        const requestId = nested && nested.request_id ? nested.request_id : '';

        if (nested && nested.ok === true) {
            return { ok: true, data: nested.data || {}, requestId, message: '' };
        }
        if (payload && payload.code === 200) {
            return { ok: true, data: payload.data || {}, requestId, message: '' };
        }

        const error = nested && nested.error ? nested.error : null;
        const message = error && error.message ? error.message : '요청을 완료하지 못했습니다.';
        return { ok: false, data: null, requestId, message, retryable: !!(error && error.retryable) };
    }
}

export default PortalHanscribeEncounterBoardComponent;